/* ============================================================
   mossen-bar.js — Panneau unifié draggable, style Prada
   ============================================================ */

/* ---------- STYLES ---------- */
(function injectStyles() {
  if (document.getElementById('mossen-bar-styles')) return;
  var s = document.createElement('style');
  s.id = 'mossen-bar-styles';
  s.textContent = `

    html, body {
      overscroll-behavior-y: none;
    }

    /* ========== PANNEAU UNIFIÉ ========== */
    #mp-unified {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: #fff;
  z-index: 100000;
  display: flex;
  flex-direction: column;
  will-change: transform;
  contain: layout size;
  /* FIX FLASH : caché par défaut très bas, avant que calcH s'exécute */
  transform: translateY(200vh);
}
    #mp-unified.mp-is-open {
      z-index: 1000000;
    }

    /* ---- Zone header (draggable) ---- */
    #mp-header {
  flex-shrink: 0;
  cursor: grab;
  user-select: none;
  -webkit-user-select: none;
  background: #fff;
  touch-action: none;
}
    #mp-header:active { cursor: grabbing; }

    #mp-drag-line-wrap {
      display: flex;
      justify-content: center;
      padding: 14px 0 10px;
    }
    #mp-drag-line {
      width: 60px;
      height: 1px;
      background: #111;
      border-radius: 0px;
    }

    #mp-mini-info { padding: 0 20px 8px; }
    #mp-mini-title {
      font-family: Arial, sans-serif;
      font-size: 13px;
      font-weight: 700;
      color: #111;
      margin: 0 0 4px;
      line-height: 1.3;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    #mp-mini-price {
      font-family: Arial, sans-serif;
      font-size: 13px;
      color: #111;
      margin: 0;
    }

    #mp-mini-btn-wrap { 
      padding: 0 20px 0px !important;
      margin-bottom: 12px;
    }
        #mp-mini-btn {
  display: block;
  width: 100%;
  background: #111 !important;
  color: #fff !important;
  border: 1px solid #111 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  padding: 11px 20px;
  font-family: Arial, sans-serif;
  font-size: 10px;
  font-weight: 400;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  cursor: pointer;
  box-sizing: border-box;
}

    /* ---- Corps scrollable ---- */
    #mp-body {
    flex: 1;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
    padding: 0 20px 0; /* Passage de 40px à 0px en bas */
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.2s ease;
  }

    /* Désactive le scroll interne tant que le panneau n'est pas ouvert */
#mp-unified:not(.mp-is-open) #mp-scroll-area {
  overflow: hidden !important;
  touch-action: none;
}

#mp-unified.mp-is-open #mp-scroll-area {
  overflow-y: auto !important;
  touch-action: pan-y;
}

    .mp-color-section {
      padding: 16px 0;
      border-bottom: 1px solid #e5e5e5;
    }
    .mp-color-row {
      font-family: Arial, sans-serif;
      font-size: 12px;
      color: #111;
      margin: 0 0 10px;
    }
    .mp-color-row strong { font-weight: 700; }
    .mp-color-swatch {
      width: 26px; height: 26px;
      border-radius: 50%;
      border: 1.5px solid #111;
      box-shadow: 0 0 0 2px #fff, 0 0 0 3.5px #111;
      box-sizing: border-box;
    }

    .mp-size-section { padding: 16px 0 0; }
    .mp-size-row {
      margin-bottom: 16px;
    }
    #mp-size-trigger {
      width: 100%;
      display: flex;
      justify-content: space-between; /* Pousse le + tout à droite */
      align-items: center;
    }
    #mp-size-icon {
      font-size: 16px;
      font-weight: 700;
      line-height: 1;
      display: inline-block;
      width: 12px;
      text-align: center;
    }
    #mp-size-list {
      margin-bottom: 12px;
      display: none;
    }
    .mp-size-item {
      display: block; width: 100%;
      background: none; border: none;
      border-bottom: 1px solid #f0f0f0;
      padding: 14px 16px;
      font-family: Arial, sans-serif;
      font-size: 14px; color: #111;
      text-align: left; cursor: pointer;
    }
    .mp-size-item:last-child { border-bottom: none; }
    .mp-size-item.selected { font-weight: 700; }
    .mp-size-item.unavailable { color: #bbb; text-decoration: line-through; cursor: default; }
    #mp-size-error {
      font-family: Arial, sans-serif;
      font-size: 11px; color: #c00;
      margin: 0 0 12px; display: none;
    }
    #mp-size-error.visible { display: block; }
    .mp-find-size {
      display: inline-block;
      font-family: Arial, sans-serif;
      font-size: 12px; color: #111;
      text-decoration: underline;
      text-underline-offset: 3px;
      background: none; border: none;
      padding: 0 0 16px; cursor: pointer;
    }

    .mp-add-btn {
      display: block; width: 100%;
      background: #111; color: #fff;
      border: none; padding: 18px 20px;
      font-family: Arial, sans-serif;
      font-size: 11px; font-weight: 700;
      letter-spacing: 0.18em; text-transform: uppercase;
      cursor: pointer; box-sizing: border-box;
    }

    .mp-sep { border: none; border-top: 1px solid #e5e5e5; margin: 20px 0 0; }
    .mp-accordion-item { border-bottom: 1px solid #e5e5e5; }
    .mp-accordion-toggle {
      display: flex; justify-content: space-between; align-items: center;
      width: 100%; background: none; border: none;
      padding: 18px 0;
      font-family: Arial, sans-serif; font-size: 12px; color: #111;
      text-align: left; cursor: pointer;
      text-decoration: underline; text-underline-offset: 3px;
    }
    .mp-accordion-body {
      font-family: Arial, sans-serif; font-size: 12px;
      color: #555; line-height: 1.7;
      padding: 0 0 16px; display: none;
    }
    .mp-accordion-body.open { display: block; }

    /* ========== AJOUTÉ AU PANIER ========== */
    #mossen-added-overlay {
      position: fixed; inset: 0;
      background: rgba(255,255,255,0.5);
      z-index: 1000040;
    }
    #mossen-added-panel {
      position: fixed; bottom: 0; left: 0; right: 0;
      background: rgba(255,255,255,0.92);
      backdrop-filter: blur(20px) saturate(180%);
      -webkit-backdrop-filter: blur(20px) saturate(180%);
      z-index: 1000050;
      border-top: 1px solid rgba(0,0,0,0.06);
      border-radius: 20px 20px 0 0;
      box-shadow: 0 -6px 40px rgba(0,0,0,0.10);
      max-height: 90vh; overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      overscroll-behavior: contain;
      transform: translateY(100%);
      transition: transform 0.4s cubic-bezier(0.25,1,0.5,1);
      padding-bottom: env(safe-area-inset-bottom, 16px);
    }
    #mossen-added-panel.open { transform: translateY(0); }

    /* ========== GUIDE ========== */
    #mossen-guide-panel {
      position: fixed; inset: 0;
      background: #fff; z-index: 1000060;
      overflow-y: auto; -webkit-overflow-scrolling: touch;
      overscroll-behavior: contain;
    }

  .mp-custom-links {
    margin-top: 30px;    /* Réduit l'espace au-dessus */
    margin-bottom: 20px; /* Réduit l'espace en-dessous */
    display: flex;
    flex-direction: column;
    gap: 25px;           /* Rapproche les liens entre eux */
  }

.mp-link-item {
    position: relative;
    font-family: Arial, sans-serif;
    font-size: 13px;
    font-weight: 400;
    color: #111;
    text-transform: none;
    text-decoration: none;
    letter-spacing: 0.02em;
    cursor: pointer;
    border: none;
    background: none;
    padding: 0 0 6px 0;
    text-align: left;
    width: fit-content;
  }

  /* 1. Ligne grise toujours visible en fond */
  .mp-link-item::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: #e5e5e5; /* Gris clair */
  }

  /* 2. Ligne noire animée qui vient recouvrir la ligne grise */
  .mp-link-item::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 1px;
    background-color: #111; /* Noir */
    transition: width 0.3s ease-out;
    z-index: 1; /* S'assure que le noir passe au-dessus du gris */
  }

  /* État actif : la ligne noire s'étend à 100% */
  .mp-link-item.is-active::after {
    width: 100%;
  }

  /* --- AJOUT DU CARROUSEL ICI --- */
  #mp-reco-grid {
    display: flex !important;
    flex-direction: row !important;
    overflow-x: auto !important;
    scroll-snap-type: x mandatory;
    gap: 2px !important;
    margin: 0 -20px !important;
    padding: 0 0 15px 0 !important; /* Passage de 30px à 15px */
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
  }

  #mp-reco-grid::-webkit-scrollbar {
    display: none;
  }

  #mp-reco-grid a {
  flex: 0 0 42% !important;
  min-width: 42% !important;
  scroll-snap-align: center;
  background: #f9f9f9;
}

#mp-reco-grid a div {
  padding-bottom: 110% !important;
}

#mp-reco-grid a span {
  padding: 6px 8px 0;
  font-size: 10px !important;
  letter-spacing: 0.02em !important;
  text-transform: uppercase !important;
  display: block !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

  /* ========== NOUVEAU CORRECTIF ORDINATEUR / DESKTOP ========== */
  @media screen and (min-width: 750px) {
    /* 1. Masque la colonne native de droite */
    body.template-product .product__info-wrapper,
    body.template-product .product-details {
      display: none !important;
    }

    /* 2. Fixation géométrique de la colonne des images (gauche) et du panneau (droite) */
    body.template-product .media-gallery,
    body.template-product .media-gallery__grid,
    body.template-product .product__media-wrapper {
      max-width: 50% !important;
      width: 50% !important;
    }

    #mp-unified {
      display: flex !important;
      position: fixed !important;
      top: 60px !important;
      right: 0 !important;
      left: 50% !important;
      bottom: 0 !important;
      width: 50% !important;
      z-index: 50 !important;
      padding-top: 0 !important;
      transform: none !important; 
      height: calc(100vh - 60px) !important;
    }

    /* 3. DÉBLOCAGE RADICAL DU SCROLL SUR ORDINATEUR */
    #mp-unified:not(.mp-is-open) #mp-scroll-area,
    #mp-unified.mp-is-open #mp-scroll-area,
    #mp-unified #mp-scroll-area {
      flex: 1 !important;
      min-height: 0 !important;
      overflow-y: auto !important;
      overflow-x: hidden !important;
      touch-action: auto !important;
      pointer-events: auto !important;
      display: flex !important;
      flex-direction: column !important;
    }

    #mp-unified #mp-body {
      opacity: 1 !important;
      visibility: visible !important;
      overflow-y: visible !important;
    }

    /* 4. NETTOYAGE DE LA GALERIE & FORCE LE FORMAT UNIQUE 1130X1600 AVEC MANGES DE 1.5CM */
    body.template-product .media-gallery__grid,
    body.template-product .product__media-list,
    body.template-product slider-component {
      display: block !important;
      width: 100% !important;
      margin: 0 !important;
      padding: 0 0 0 1.5cm !important; /* Marge blanche de 1,5 cm par rapport au bord gauche du site */
      box-sizing: border-box !important;
    }

    /* ===== THÈME WEB-COMPONENTS : harmonisation 1130x1600 ===== */

    /* 1. Neutralise la hauteur en dvh imposée à chaque slide */
    body.template-product .media-gallery slideshow-slide,
    body.template-product .media-gallery .product-media-container {
      display: block !important;
      --grid-template-rows: auto !important;
      --grid-template-rows-desktop: auto !important;
      grid-template-rows: auto !important;
      height: auto !important;
      min-height: 0 !important;
      max-height: none !important;
      margin: 0 0 1.5cm 0 !important;
    }

    /* 2. LE conteneur à ratio : on écrase le --ratio natif de chaque image */
    body.template-product .media-gallery .product-media {
      --ratio: 0.70625 !important;       /* 1130 / 1600 */
      aspect-ratio: 1130 / 1600 !important;
      width: 100% !important;
      height: auto !important;
      padding: 0 !important;
      overflow: hidden !important;
      position: relative !important;
    }

    /* 3. L'image remplit exactement le conteneur */
    body.template-product .media-gallery .product-media__image,
    body.template-product .product-media-container img,
    body.template-product .media-gallery__grid img {
      position: absolute !important;
      inset: 0 !important;
      width: 100% !important;
      height: 100% !important;
      max-width: 100% !important;
      aspect-ratio: auto !important;
      object-fit: cover !important;
      object-position: center !important;
      margin: 0 !important;
      border-radius: 0 !important;
    }

    /* Supprime les boutons de navigation, diaporamas mobiles cachés et clones */
    body.template-product slideshow-component + .product-media-container,
    body.template-product .slider-buttons,
    body.template-product .thumbnail-list,
    body.template-product .thumbnail-slider {
      display: none !important;
    }

    /* 5. SUPPRESSION DES ÉLÉMENTS ET BOUTONS MOBILES SUR INTERFACE DE BUREAU */
    #mp-unified #mp-header,
    #mp-unified #mp-drag-line-wrap,
    #mp-unified #mp-mini-btn-wrap,
    #mp-unified #mp-mini-thumbs-wrap {
      display: none !important;
      height: 0 !important;
      padding: 0 !important;
      margin: 0 !important;
    }
    
    #mp-unified #mp-mini-info {
      padding-top: 25px !important;
      margin-bottom: 35px !important;
      opacity: 1 !important;
      visibility: visible !important;
    }

    /* 6. POLICES ET ESPACES BLANCS GRAND FORMAT (STYLE PRADA) */
    #mp-unified #mp-mini-title {
      font-size: 18px !important;
      margin-bottom: 12px !important;
    }
    #mp-unified #mp-mini-price {
      font-size: 16px !important;
    }
    #mp-unified .mp-color-section {
      margin-bottom: 35px !important;
      padding-bottom: 20px !important;
    }
    #mp-unified .mp-color-row {
      font-size: 14px !important;
      margin-bottom: 14px !important;
    }
    #mp-unified .mp-size-section {
      margin-bottom: 45px !important;
    }
    #mp-unified #mp-size-label,
    #mp-unified #mp-size-icon,
    #mp-unified .mp-find-size {
      font-size: 14px !important;
    }
    #mp-unified .mp-add-btn {
      font-size: 13px !important;
      padding: 20px !important;
      margin-bottom: 25px !important;
    }
    #mp-unified .mp-custom-links {
      gap: 32px !important;
      margin-top: 45px !important;
      margin-bottom: 50px !important;
    }
    #mp-unified .mp-link-item {
      font-size: 14px !important;
      padding-bottom: 10px !important;
    }
    #mp-unified #mp-reco-section {
      margin-top: 60px !important;
    }
    #mp-unified #mp-reco-section > p {
      font-size: 15px !important;
      margin-bottom: 35px !important;
    }
  }

/* ===== MOBILE : retrait des filets gris pour plus de minimalisme ===== */
  @media screen and (max-width: 749px) {
    #mp-unified .mp-custom-links hr,
    #mp-unified #mp-body > hr {
      display: none !important;
    }
    #mp-unified .mp-custom-links {
      gap: 34px !important;
    }
  }

  `;
  document.head.appendChild(s);
})();

/* ============================================================
   PANNEAU UNIFIÉ
   ============================================================ */
document.addEventListener('DOMContentLoaded', function () {
  if (!window.location.pathname.includes('/products/')) return;

  function init() {
    if (document.getElementById('mp-unified')) return;

    var titleEl = document.querySelector('h1');
    var priceEl = document.querySelector('.price');
    var title   = titleEl ? titleEl.innerText.trim() : '';
    var price   = priceEl ? priceEl.innerText.trim() : '';

    /* ---- Détection SAC (robuste) ---- */
    /* On commence avec les indices URL et titre */
    var isBag = window.location.pathname.match(/sac|bag|pochette|clutch|maroquin/i) !== null ||
      (titleEl && titleEl.innerText.toLowerCase().match(/sac|bag|pochette|clutch|maroquin/) !== null);

    /* On affine via le JSON produit (tags/type) */
    fetch(window.location.pathname + '.json')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        window.__mossen_product_id = d.product.id;
        var type = (d.product.product_type || '').toLowerCase();
        var tags = (d.product.tags || []).join(' ').toLowerCase();
        if (type.match(/sac|bag|maroquin|pochette|clutch/) || tags.match(/sac|bag|maroquin|pochette|clutch/)) {
          isBag = true;
          /* Met à jour le bouton mini si nécessaire */
          var btn = document.getElementById('mp-mini-btn');
          if (btn) btn.textContent = 'AJOUTER AU PANIER';
          
          /* Affiche les 3 dimensions de force pour les sacs à main */
          var dimContainer = document.getElementById('mp-dimensions-container');
          if (dimContainer) dimContainer.style.display = 'flex';
        }
      })
      .catch(function () {});

    /* Couleur */
    var colorLabel = '', colorBg = '';
    document.querySelectorAll('.variant-option').forEach(function (opt) {
      var lbl = opt.querySelector('.variant-option__label, label');
      if (lbl && lbl.innerText.toLowerCase().includes('couleur')) {
        var sel = opt.querySelector('.variant-option__button--selected, .selected, input:checked + label');
        if (sel) colorLabel = sel.innerText.trim();
        var sw = opt.querySelector('[style*="background"], .swatch, .color-swatch');
        if (sw) colorBg = sw.style.backgroundColor || sw.style.background || '';
      }
    });

    /* Tailles */
    var sizes = [], selectedSize = '';
    document.querySelectorAll('.variant-option').forEach(function (opt) {
      var lbl = opt.querySelector('.variant-option__label, label');
      if (lbl && (lbl.innerText.toLowerCase().includes('taille') || lbl.innerText.toLowerCase().includes('size'))) {
        var sel = opt.querySelector('.variant-option__button--selected, .selected');
        if (sel) selectedSize = sel.innerText.trim();
      }
    });
    document.querySelectorAll('.variant-option__button-label').forEach(function (bl) {
      var pb = bl.closest('button, .variant-option__button');
      sizes.push({ label: bl.innerText.trim(), el: bl, unavailable: pb ? (pb.disabled || pb.classList.contains('disabled') || pb.classList.contains('variant-option__button--unavailable')) : false });
    });
    if (!sizes.length) {
      var sel = document.querySelector('select[name*="Taille"],select[name*="taille"],select[name*="Size"],select[name*="size"]');
      if (sel) Array.from(sel.options).forEach(function (o) { if (o.value) sizes.push({ label: o.text.trim(), el: sel, value: o.value, unavailable: false }); });
    }
    if (!sizes.length) {
      document.querySelectorAll('input[type=radio]').forEach(function (inp) {
        var lbl = document.querySelector('label[for="' + inp.id + '"]') || inp.closest('label');
        if (lbl) sizes.push({ label: lbl.innerText.trim(), el: inp, unavailable: inp.disabled });
      });
    }
    window._mossenSizes = sizes;

    /* Articles taille unique (accessoires) : pas de sélecteur de taille */
    var _uniqLabel = /^(taille\s*unique|unique|t\.?u\.?|os|one\s*size)$/i;
    var hasRealSizes = sizes.some(function (s) { return s.label && !_uniqLabel.test(s.label.trim()); });
    window._mossenHasRealSizes = hasRealSizes;

  /* --- Miniatures centrées, plus grandes et cliquables --- */
    window._mossenThumbImgs = [];
document.querySelectorAll('.product-media-container img, .media-gallery__grid img, .product__media-item img').forEach(function(img) {
  var src = img.getAttribute('src') || img.currentSrc;
  if (src && !window._mossenThumbImgs.includes(src)) {
    window._mossenThumbImgs.push(src);
  }
});
var thumbImgs = window._mossenThumbImgs;

    var thumbsHTML = '';
    if (thumbImgs.length > 0) {
      thumbsHTML = '<div id="mp-mini-thumbs-wrap" style="display:flex; justify-content:center; gap:8px; padding:0 20px; max-height:0; opacity:0; overflow-x:auto; -webkit-overflow-scrolling:touch; scrollbar-width:none; transition:all 0.3s ease;">' +
        thumbImgs.map(function(src, idx) {
  return '<img src="' + src + '" onclick="mossenPreviewImg(\'' + src + '\', event, ' + idx + ')" style="width:75px; min-width:75px; height:100px; object-fit:cover; border-radius:4px; border:1px solid #e5e5e5; cursor:pointer;">';
}).join('') +
      '</div>';
    }

    /* HTML */
    var colorHTML = colorLabel
      ? '<div class="mp-color-section"><p class="mp-color-row"><strong>Couleur</strong>&nbsp; ' + colorLabel + '</p>' +
        (colorBg ? '<div class="mp-color-swatch" style="background:' + colorBg + ';"></div>' : '') + '</div>'
      : '';

    var sizeLbl = selectedSize ? 'Taille&nbsp;&nbsp;<strong>' + selectedSize + '</strong>' : 'Taille';

    var guideEl = document.getElementById('mossen-meta-guide-tailles');
var guideContent = guideEl ? guideEl.innerHTML.trim() : '';
/* --- DICTIONNAIRE DES DIMENSIONS SACS --- */
var catalogueSacs = {
  "sac-a-main-en-cuir-pu-maison-mossen-1":   { largeur: "39 cm", hauteur: "30 cm", profondeur: "16 cm" },
  "sac-a-main-maison-mossen-en-cuir-pu":     { largeur: "34 cm", hauteur: "26 cm", profondeur: "15 cm" },
  "sac-a-main-en-cuir-pu-maison-mossen-10":  { largeur: "59 cm", hauteur: "31 cm", profondeur: "." },
  "sac-a-main-pour-les-cours-en-cuir-pu-5":  { largeur: "40 cm", hauteur: "25 cm", profondeur: "15 cm" },
  "sac-a-main-pour-les-cours-en-cuir-pu-4":  { largeur: "39 cm", hauteur: "30 cm", profondeur: "16 cm" },
  "sac-a-main-maison-mossen-en-cuir-pu-14":  { largeur: "39 cm", hauteur: "30 cm", profondeur: "16 cm" },
  "sac-a-main-maison-mossen-en-cuir-pu-1":   { largeur: "40 cm", hauteur: "29 cm", profondeur: "14 cm" },
  "sac-a-main-en-cuir-brosse-maison-mossen": { largeur: "39 cm", hauteur: "30 cm", profondeur: "16 cm" },
  "sac-a-main-en-cuir-pu-1":                 { largeur: "39 cm", hauteur: "30 cm", profondeur: "16 cm" },
  "sac-a-main-en-cuir-pu-teckel":            { largeur: "39 cm", hauteur: "30 cm", profondeur: "16 cm" }
};

var productHandle = window.location.pathname.split('/').pop();
var dimensionsActuelles = catalogueSacs[productHandle];

var largeur = dimensionsActuelles ? dimensionsActuelles.largeur : null;
var hauteur = dimensionsActuelles ? dimensionsActuelles.hauteur : null;
var profondeur = dimensionsActuelles ? dimensionsActuelles.profondeur : null;

var dimensionsHTML =
  '<div id="mp-dimensions-container" style="display:' + (isBag ? 'flex' : 'none') + ';gap:0;margin-top:16px;">' +

    /* ── LARGEUR ── */
    '<div style="flex:1;padding:14px 0;text-align:center;">' +
      '<p style="font-family:Arial,sans-serif;font-size:9px;letter-spacing:0.12em;text-transform:uppercase;color:#111;margin:0 0 8px;">Largeur</p>' +
      '<svg width="24" height="28" viewBox="0 0 52 56" xmlns="http://www.w3.org/2000/svg" style="display:block;margin:0 auto 6px;overflow:visible;">' +
        '<defs>' +
          '<marker id="mp-al" markerWidth="5" markerHeight="5" refX="4" refY="2.5" orient="auto-start-reverse">' +
            '<path d="M0,0 L5,2.5 L0,5" fill="none" stroke="#111" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</marker>' +
        '</defs>' +
        '<path d="M17,16 Q17,7 26,7 Q35,7 35,16" fill="none" stroke="#ccc" stroke-width="1.5" stroke-linecap="round"/>' +
        '<rect x="5" y="16" width="42" height="28" rx="2" fill="none" stroke="#ccc" stroke-width="1.5"/>' +
        '<line x1="5" y1="52" x2="47" y2="52" stroke="#111" stroke-width="1.2" marker-start="url(#mp-al)" marker-end="url(#mp-al)"/>' +
      '</svg>' +
      '<p style="font-family:Arial,sans-serif;font-size:13px;color:#111;margin:0;font-weight:400;">' + (largeur || '-') + '</p>' +
    '</div>' +

    /* ── HAUTEUR ── */
    '<div style="flex:1;padding:14px 0;text-align:center;">' +
      '<p style="font-family:Arial,sans-serif;font-size:9px;letter-spacing:0.12em;text-transform:uppercase;color:#111;margin:0 0 8px;">Hauteur</p>' +
      '<svg width="24" height="28" viewBox="0 0 52 56" xmlns="http://www.w3.org/2000/svg" style="display:block;margin:0 auto 6px;overflow:visible;">' +
        '<defs>' +
          '<marker id="mp-ah" markerWidth="5" markerHeight="5" refX="4" refY="2.5" orient="auto-start-reverse">' +
            '<path d="M0,0 L5,2.5 L0,5" fill="none" stroke="#111" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</marker>' +
        '</defs>' +
        '<path d="M17,16 Q17,7 26,7 Q35,7 35,16" fill="none" stroke="#ccc" stroke-width="1.5" stroke-linecap="round"/>' +
        '<rect x="5" y="16" width="42" height="28" rx="2" fill="none" stroke="#ccc" stroke-width="1.5"/>' +
        '<line x1="1" y1="16" x2="1" y2="44" stroke="#111" stroke-width="1.2" marker-start="url(#mp-ah)" marker-end="url(#mp-ah)"/>' +
      '</svg>' +
      '<p style="font-family:Arial,sans-serif;font-size:13px;color:#111;margin:0;font-weight:400;">' + (hauteur || '-') + '</p>' +
    '</div>' +

    /* ── PROFONDEUR ── */
    '<div style="flex:1;padding:14px 0;text-align:center;">' +
      '<p style="font-family:Arial,sans-serif;font-size:9px;letter-spacing:0.12em;text-transform:uppercase;color:#111;margin:0 0 8px;">Profondeur</p>' +
      '<svg width="24" height="28" viewBox="0 0 52 56" xmlns="http://www.w3.org/2000/svg" style="display:block;margin:0 auto 6px;">' +
        '<defs>' +
          '<marker id="mp-ap" markerWidth="5" markerHeight="5" refX="4" refY="2.5" orient="auto-start-reverse">' +
            '<path d="M0,0 L5,2.5 L0,5" fill="none" stroke="#111" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</marker>' +
        '</defs>' +
        '<polygon points="28,16 38,8 38,32 28,40" fill="#f9f9f9" stroke="#ccc" stroke-width="1.5"/>' +
        '<polygon points="2,16 12,8 38,8 28,16" fill="#f4f4f4" stroke="#ccc" stroke-width="1.5"/>' +
        '<rect x="2" y="16" width="26" height="24" rx="2" fill="white" stroke="#ccc" stroke-width="1.5"/>' +
        '<path d="M9,16 Q9,10 15,10 Q21,10 21,16" fill="none" stroke="#ccc" stroke-width="1.5" stroke-linecap="round"/>' +
        '<line x1="28" y1="28" x2="38" y2="20" stroke="#111" stroke-width="1.2" marker-start="url(#mp-ap)" marker-end="url(#mp-ap)"/>' +
      '</svg>' +
      '<p style="font-family:Arial,sans-serif;font-size:13px;color:#111;margin:0;font-weight:400;">' + (profondeur || '-') + '</p>' +
    '</div>' +

  '</div>';
var guideLinkHTML = '<button class="mp-find-size" style="padding:0;" onclick="mossenOpenGuideContent()">Dimensions</button>';
    var sizeHTML = (isBag || !hasRealSizes) ? '' :
      '<div class="mp-size-section">' +
        '<div class="mp-size-row">' +
          '<button id="mp-size-trigger" class="mp-link-item" onclick="mossenToggleSizeList()">' +
            '<span id="mp-size-label">' + sizeLbl + '</span>' +
            '<span id="mp-size-icon">+</span>' +
          '</button>' +
        '</div>' +
        '<div id="mp-size-list">' +
          sizes.map(function (s, i) {
            return '<button class="mp-size-item' + (s.unavailable ? ' unavailable' : '') + (s.label === selectedSize ? ' selected' : '') + '"' +
              (s.unavailable ? ' disabled' : '') + ' onclick="mossenSelectSize(' + i + ',this)">' + s.label + '</button>';
          }).join('') +
        '</div>' +
        '<p id="mp-size-error" class="mp-size-error">Vous devez choisir au moins une taille</p>' +
        '<div style="display:flex;justify-content:space-between;align-items:center;padding-bottom:16px;">' +
  guideLinkHTML +
  '<button class="mp-find-size" style="padding:0;" onclick="mossenCloseFull();showGuidePanel();">Trouver ma taille</button>' +
'</div>' +
      '</div>';
    var customLinksHTML = 
      '<div class="mp-custom-links" style="margin-top: 30px; margin-bottom: 20px; display: flex; flex-direction: column; gap: 30px;">' +
        '<div>' +
          '<button class="mp-link-item" onclick="mossenToggleDirectAcc(this, \'description\')">Description</button>' +
          '<div class="mp-link-body" style="display:none; padding-top:12px; font-family:Arial,sans-serif; font-size:12px; color:#555; line-height:1.6;"></div>' +
        '</div>' +
        '<hr style="border:none;border-top:1px solid #f0f0f0;margin:0;">' +
        '<div>' +
          '<button class="mp-link-item" onclick="mossenToggleDirectAcc(this, \'matiere\')">Matière</button>' +
          '<div class="mp-link-body" style="display:none; padding-top:12px; font-family:Arial,sans-serif; font-size:12px; color:#555; line-height:1.6;"></div>' +
        '</div>' +
        '<hr style="border:none;border-top:1px solid #f0f0f0;margin:0;">' +
        '<div>' +
          '<button class="mp-link-item" onclick="mossenToggleDirectAcc(this, \'livraison\')">Livraison gratuite</button>' +
          '<div class="mp-link-body" style="display:none; padding-top:12px; font-family:Arial,sans-serif; font-size:12px; color:#555; line-height:1.6;"></div>' +
        '</div>' +
        '<hr style="border:none;border-top:1px solid #f0f0f0;margin:0;">' +
        '<div>' +
          '<a href="/pages/contact" class="mp-link-item">Nous contacter</a>' +
        '</div>' +
      '</div>' +
      '<div id="mp-reco-section" style="margin-top: 20px;">' +
        '<p style="font-family:Arial,sans-serif;font-size:13px;color:#111;margin: 0 0 45px;font-weight:600;text-align:center;letter-spacing:0.05em;">Vous aimerez sûrement</p>' +
        '<div id="mp-reco-grid" style="display:grid;grid-template-columns:repeat(2,1fr);gap:30px 20px;">' +
          '<div style="font-size:11px;color:#aaa;font-family:Arial;">Chargement...</div>' +
        '</div>' +
      '</div>';

    /* --- NOUVEAU FOOTER PRADA ÉPURÉ AVEC CONTACT DÉTAILLÉ --- */
    var footerHTML =
      '<style>' +
      '.ms-foot-det { border-bottom: 1px solid #e5e5e5; padding: 0 20px; }' +
      '.ms-foot-sum { display: flex; justify-content: space-between; align-items: center; list-style: none; padding: 24px 0; cursor: pointer; font-family: Arial, sans-serif; font-weight: 700; font-size: 11px; letter-spacing: 0.05em; color: #111; text-transform: uppercase; }' +
      '.ms-foot-sum::-webkit-details-marker { display: none; }' +
      '.ms-foot-det[open] svg { transform: rotate(180deg); }' +
      '.ms-foot-det[open] svg { transform: rotate(180deg); }' +
      '.ms-foot-body { padding: 0 0 20px; }' +
      '.ms-foot-body a { display: block; margin-bottom: 16px; color: #111; text-decoration: none; font-size: 11px; font-family: Arial, sans-serif; font-weight: 400; text-transform: uppercase; }' +
      '.ms-foot-body p { margin: 0 0 16px; color: #111; font-size: 11px; font-family: Arial, sans-serif; line-height: 1.6; }' +
      '.ms-foot-body p:last-child { margin-bottom: 0; }' +
      '</style>' +
      '<div id="mp-full-footer" style="margin-top: 0px; background: #fff; margin-left: -20px; margin-right: -20px; text-align: left;">' +

        /* BLOC NEWSLETTER */
        '<div style="padding: 20px 20px; border-bottom: 1px solid #e5e5e5;">' +
          '<p style="font-family: Arial, sans-serif; font-size: 11px; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; color: #111; margin: 0 0 24px;">Newsletter</p>' +
          '<div style="display: flex; align-items: center; border-bottom: 1px solid #111; padding-bottom: 8px; margin-bottom: 12px;">' +
            '<input type="email" placeholder="Votre adresse e-mail" style="flex: 1; border: none; outline: none; font-size: 12px; font-family: Arial, sans-serif; color: #111; background: transparent; padding: 0;">' +
            '<button onclick="mossenSubmitNewsletter(this)" style="background: none; border: none; cursor: pointer; padding: 0; display: flex; align-items: center;"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#111" stroke-width="1.2"><path d="M5 12h14M12 5l7 7-7 7"/></svg></button>' +
          '</div>' +
          '<p style="font-family: Arial, sans-serif; font-size: 9px; color: #888; margin: 0 0 32px;">En vous inscrivant, vous acceptez notre <a href="/policies/privacy-policy" style="color: #111; text-decoration: underline;">Politique de confidentialité</a>.</p>' +
          '<div style="display: flex; gap: 24px; align-items: center;">' +
  '<a href="https://www.instagram.com/maisonmossen" target="_blank" style="display:flex;align-items:center;color:#111;"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#111" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg></a>' +
  '<a href="https://www.tiktok.com/@maison_mossen" target="_blank" style="display:flex;align-items:center;color:#111;"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#111" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5"></path></svg></a>' +
'</div>' +
        '</div>' +

        /* ACCORDÉON 1 : NOUS CONTACTER (MIS À JOUR) */
        '<details class="ms-foot-det">' +
          '<summary class="ms-foot-sum">NOUS CONTACTER <svg width="12" height="7" viewBox="0 0 12 7" fill="none" stroke="#111" stroke-width="1.5" style="transition: transform 0.3s;"><path d="M1 1l5 5 5-5"/></svg></summary>' +
          '<div class="ms-foot-body">' +
            '<p><strong>Téléphone :</strong> 0 688 660 050<br>Disponible pour vos appels de 9h à 18h30 du lundi au samedi.</p>' +
            '<p><strong>Email :</strong> sav@maisonmossen.com<br>Nous répondons à vos emails dans les plus brefs délais, du lundi au samedi.</p>' +
          '</div>' +
        '</details>' +

        /* ACCORDÉON 2 : INFORMATIONS UTILES */
        '<details class="ms-foot-det">' +
          '<summary class="ms-foot-sum">INFORMATIONS UTILES <svg width="12" height="7" viewBox="0 0 12 7" fill="none" stroke="#111" stroke-width="1.5" style="transition: transform 0.3s;"><path d="M1 1l5 5 5-5"/></svg></summary>' +
          '<div class="ms-foot-body">' +
            '<a href="/pages/livraison">LIVRAISON</a>' +
            '<a href="/policies/refund-policy">ÉCHANGES, RETOURS ET REMBOURSEMENTS</a>' +
            '<a href="/pages/guide-des-tailles">GUIDE DES TAILLES</a>' +
            '<a href="/pages/paiements-securises-et-factures">PAIEMENTS SÉCURISÉS ET FACTURES</a>' +
            '<a href="/pages/disponibilite-des-articles">DISPONIBILITÉ DES ARTICLES</a>' +
            '<a href="/pages/cartes-cadeaux">CARTE CADEAU</a>' +
            '<a href="/pages/international">INTERNATIONAL</a>' +
            '<a href="/pages/mes-achats">MES ACHATS</a>' +
            '<a href="/pages/a-propos-de-l-entreprise-mossen">À PROPOS DE L\'ENTREPRISE MOSSEN</a>' +
            '<a href="/pages/carriere">CARRIÈRE</a>' +
            '<a href="/pages/showroom-on-vous-offre-le-cafe-avec-ou-sans-sucre">MAGASINS EN FRANCE</a>' +
            '<a href="/collections/fabrique-en-france">FABRIQUÉS EN FRANCE</a>' +
            '<a href="/pages/reseaux-sociaux">RÉSEAUX SOCIAUX</a>' +
          '</div>' +
        '</details>' +

        /* ACCORDÉON 3 : MENTIONS LÉGALES ET POLITIQUES */
        '<details class="ms-foot-det">' +
          '<summary class="ms-foot-sum">MENTIONS LÉGALES ET POLITIQUES <svg width="12" height="7" viewBox="0 0 12 7" fill="none" stroke="#111" stroke-width="1.5" style="transition: transform 0.3s;"><path d="M1 1l5 5 5-5"/></svg></summary>' +
          '<div class="ms-foot-body">' +
            '<a href="/policies/terms-of-service">CONDITIONS GÉNÉRALES DE VENTE</a>' +
            '<a href="/policies/privacy-policy">POLITIQUE DE CONFIDENTIALITÉ</a>' +
            '<a href="/policies/legal-notice">MENTIONS LÉGALES</a>' +
            '<a href="/pages/data-sharing-opt-out" onclick="if(window.privacyBanner&&window.privacyBanner.showPreferences){window.privacyBanner.showPreferences();return false;}">GESTION DES COOKIES</a>' +
          '</div>' +
        '</details>' +

        /* INFOS LÉGALES FINALES */
        '<div style="padding: 24px 20px 40px; text-align: center; background: #f9f9f9;">' +
          '<p style="font-family: Arial, sans-serif; font-size: 9px; line-height: 1.6; font-weight: 400; color: #888; letter-spacing: 0.03em; margin: 0;">' +
            '©MOSSEN SAS | Siège social : 1 Promenade des Capitouls, 31000 Toulouse, France | Capital social : 1 000 euros | Numéro de TVA : FR47942046681 | Téléphone : +33 6 88 66 00 50' +
          '</p>' +
        '</div>' +

      '</div>';

   /* --- Calcul livraison (J+5 à J+7) sans dimanche --- */
    var deliveryText = (function() {
      var jours = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
      var mois = ['janv.', 'févr.', 'mars', 'avr.', 'mai', 'juin', 'juil.', 'août', 'sept.', 'oct.', 'nov.', 'déc.'];
      function eviterDim(d) { if (d.getDay() === 0) d.setDate(d.getDate() + 1); return d; }
      var d = eviterDim(new Date(Date.now() + 3 * 86400000));
      return jours[d.getDay()] + ' ' + d.getDate() + ' ' + mois[d.getMonth()];
    })();
    window._mossenDeliveryText = deliveryText;

    var commandeText = (function() {
      var now = new Date();
      var cutoffH = 17, cutoffM = 0;
      var heureActuelle = now.getHours() + now.getMinutes() / 60;
      if (heureActuelle >= cutoffH) return null;
      var restMin = Math.floor((cutoffH * 60 + cutoffM) - (now.getHours() * 60 + now.getMinutes()));
      var h = Math.floor(restMin / 60);
      var m = restMin % 60;
      return 'Commandez dans les <span style="color:#2a9d4e;">' + h + ' h ' + (m < 10 ? '0' : '') + m + ' min</span>.';
    })();

    var unified = document.createElement('div');
    unified.id  = 'mp-unified';
    unified.innerHTML =
      '<div id="mp-header" style="background:#fff; flex-shrink:0; cursor:grab; z-index:20;">' +
        '<div id="mp-drag-line-wrap"><div id="mp-drag-line"></div></div>' +
      '</div>' +
      '<div id="mp-scroll-area" style="flex:1; overflow-y:auto; -webkit-overflow-scrolling:touch; overscroll-behavior:contain; display:flex; flex-direction:column;">' +
        '<div id="mp-header-content" style="flex-shrink:0; background:#fff; cursor:grab; user-select:none;">' +
          thumbsHTML + 
          '<div id="mp-mini-info"><p id="mp-mini-title">' + title + '</p><p id="mp-mini-price">' + price + '</p></div>' +
          '<div id="mp-mini-btn-wrap"><button id="mp-mini-btn">' + ((isBag || !hasRealSizes) ? 'AJOUTER AU PANIER' : 'TAILLE') + '</button></div>' +
        '</div>' +
        '<div id="mp-body" style="flex:1; overflow-y:visible;">' +
        '<hr style="border:none;border-top:1px solid #e5e5e5;margin:0 0 16px;">' +
        colorHTML + sizeHTML +
        '<div id="mp-livraison-block" style="display:' + (isBag ? 'flex' : 'none') + ';align-items:flex-start;gap:14px;padding:16px 0 12px;">' +
          '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#111" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;margin-top:2px;"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>' +
          '<div style="flex:1;">' +
            '<p style="font-family:Arial,sans-serif;font-size:13px;font-weight:700;color:#111;margin:0 0 3px;">Livraison express gratuite — 2 jours</p>' +
            '<p style="font-family:Arial,sans-serif;font-size:13px;color:#111;margin:0 0 3px;">Livré avant le <strong>' + deliveryText + '</strong>' + (commandeText ? '. ' + commandeText : '') + '</p>' +
            '<div style="display:flex;align-items:center;gap:6px;margin:3px 0 6px;">' +
              '<svg width="16" height="16" viewBox="0 0 24 24" fill="none"><defs><linearGradient id="mm-fr-check2" x1="0%" y1="0%" x2="100%" y2="0%"><stop offset="0%" stop-color="#0055A4"/><stop offset="50%" stop-color="#0055A4"/><stop offset="50%" stop-color="#EF4135"/><stop offset="100%" stop-color="#EF4135"/></linearGradient></defs><path d="M20 6L9 17l-5-5" stroke="url(#mm-fr-check2)" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
              '<span style="font-family:Arial,sans-serif;font-size:13px;color:#111;">Expédié depuis la France</span>' +
            '</div>' +
            '<button onclick="mossenOpenLivraisonDetail(event)" style="background:none;border:none;padding:0;cursor:pointer;font-family:Arial,sans-serif;font-size:13px;color:#0a3d91;text-decoration:underline;text-underline-offset:3px;text-align:left;display:inline;">Détails</button>' +
          '</div>' +
        '</div>' +
        '<button class="mp-add-btn" onclick="mossenAddToCart()" style="margin:20px 0 16px;">AJOUTER AU PANIER</button>' +
        (isBag ? '<div style="display:flex;justify-content:space-between;align-items:center;padding:4px 0 16px;">' +
          '<button onclick="mossenOpenGuideContent()" style="background:none;border:none;padding:0;cursor:pointer;font-family:Arial,sans-serif;font-size:13px;color:#111;text-decoration:underline;">Dimensions</button>' +
'<button onclick="mossenOpenFAQ()" style="background:none;border:none;padding:0;cursor:pointer;font-family:Arial,sans-serif;font-size:13px;color:#111;text-decoration:underline;">Questions fréquentes</button>' +
        '</div>' : '') +
      
        '<div class="mp-custom-links" style="margin-top: 30px; margin-bottom: 20px; display: flex; flex-direction: column; gap: 20px;">' +
          '<div>' +
            '<button class="mp-link-item" data-type="description" onclick="mossenToggleDirectAcc(this)">Description</button>' +
            '<div class="mp-link-body" style="display:none; padding-top:12px; font-family:Arial,sans-serif; font-size:12px; color:#555; line-height:1.6;"></div>' +
          '</div>' +
          '<hr style="border:none;border-top:1px solid #f0f0f0;margin:0;">' +
          '<div>' +
            '<button class="mp-link-item" data-type="matiere" onclick="mossenToggleDirectAcc(this)">Matière</button>' +
            '<div class="mp-link-body" style="display:none; padding-top:12px; font-family:Arial,sans-serif; font-size:12px; color:#555; line-height:1.6;"></div>' +
          '</div>' +
          '<hr style="border:none;border-top:1px solid #f0f0f0;margin:0;">' +
          '<div>' +
            '<button class="mp-link-item" data-type="livraison" onclick="mossenToggleDirectAcc(this)">Livraison gratuite, échange et retours</button>' +
            '<div class="mp-link-body" style="display:none; padding-top:12px; font-family:Arial,sans-serif; font-size:12px; color:#555; line-height:1.6;"></div>' +
          '</div>' +
          '<hr style="border:none;border-top:1px solid #f0f0f0;margin:0;">' +
          '<div>' +
            '<button class="mp-link-item" data-type="contact" onclick="mossenToggleDirectAcc(this)">Nous contacter</button>' +
            '<div class="mp-link-body" style="display:none; padding-top:12px; font-family:Arial,sans-serif; font-size:12px; color:#555; line-height:1.6;"></div>' +
          '</div>' +
        '</div>' +
        '<div id="mp-reco-section" style="margin-top: 20px;">' +
          '<p style="font-family:Arial,sans-serif;font-size:13px;color:#111;margin: 0 0 45px;font-weight:600;text-align:center;letter-spacing:0.05em;">Vous aimerez sûrement</p>' +
          '<div id="mp-reco-grid" style="display:grid;grid-template-columns:repeat(2,1fr);gap:30px 20px;">' +
            '<div style="font-size:11px;color:#aaa;font-family:Arial;">Chargement...</div>' +
          '</div>' +
        '</div>' +
        footerHTML +
      '</div>';

    document.body.appendChild(unified);

    /* Recommandations */
    fetch(window.location.pathname + '.json')
      .then(function(r) { return r.json(); })
      .then(function(d) {
        return fetch('/recommendations/products.json?product_id=' + d.product.id + '&limit=30&intent=related');
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var grid = document.getElementById('mp-reco-grid');
        if (!grid || !data.products || data.products.length === 0) return;
        grid.innerHTML = '';
        data.products.forEach(function(p) {
          var rawSrc = p.featured_image || (p.images && p.images[0]) || '';
          if (typeof rawSrc !== 'string' && rawSrc.src) rawSrc = rawSrc.src;
          var src = rawSrc.startsWith('//') ? 'https:' + rawSrc : rawSrc;
          src = src.replace(/\.(jpg|jpeg|png|webp)/g, '_1000x.$1');
          var px = p.price ? (p.price / 100).toFixed(2).replace('.', ',') + ' €' : '';
          var a = document.createElement('a');
          a.href = '/products/' + p.handle;
          /* 👇 Ajout de min-width: 0; ici aussi */
          a.style.cssText = 'text-decoration:none;color:#111;display:flex;flex-direction:column;gap:8px;min-width:0;';
          a.innerHTML =
            '<div style="position:relative; width:100%; padding-bottom:125%; overflow:hidden; background:#f9f9f9;">' +
              '<img src="' + src + '" style="position:absolute; top:0; left:0; width:100%; height:100%; object-fit:cover; image-rendering:-webkit-optimize-contrast;" onerror="this.src=\'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png\'">' +
            '</div>';
          grid.appendChild(a);
        });
      })
      .catch(function(err) { console.error("Erreur reco:", err); });

    /* ===================== DRAG & CLICK UNIFIÉ ===================== */
    var header   = document.getElementById('mp-header');
    var body     = document.getElementById('mp-body');
    var headerH  = 0, maxT = 0, currentT = 0;
    var dragging = false, startY = 0, startT = 0, distY = 0;
    var fixedViewportHeight = window.visualViewport ? window.visualViewport.height : document.documentElement.clientHeight;

    /* FIX PAGE BLANCHE : _savedMaxT calculé IMMÉDIATEMENT de façon synchrone
       On mesure le header à l'état naturel (paddingTop:0, btnWrap visible)
       avant tout appel à applyT */
    var _savedMaxT = null;

    function calcH() {
      var dragLineH = header.getBoundingClientRect().height;
      var hc = document.getElementById('mp-header-content');
      var headerContentH = hc ? hc.getBoundingClientRect().height : 0;
      headerH = dragLineH + headerContentH;
      maxT = fixedViewportHeight - headerH - 10;
    }

    /* Calcul synchrone initial — le DOM est prêt, les styles sont appliqués */
    requestAnimationFrame(function () {
  var miniInfo = document.getElementById('mp-mini-info');
  var btnWrap  = document.getElementById('mp-mini-btn-wrap');
  if (miniInfo) miniInfo.style.paddingTop = '0px';
  if (btnWrap) {
    btnWrap.style.height = '';
    btnWrap.style.overflow = '';
    btnWrap.style.opacity = '1';
    btnWrap.style.pointerEvents = 'auto';
  }
fixedViewportHeight = window.visualViewport ? window.visualViewport.height : document.documentElement.clientHeight;
  calcH();
  _savedMaxT = maxT;
  applyT(maxT, false);
});

    window.addEventListener('orientationchange', function() {
      setTimeout(function() {
        fixedViewportHeight = window.visualViewport ? window.visualViewport.height : document.documentElement.clientHeight;
        calcH();
        _savedMaxT = maxT;
        if (currentT > 0) applyT(maxT, false);
      }, 200);
    });

    var _lastOrientAngle = window.screen && window.screen.orientation ? window.screen.orientation.angle : 0;
    window.addEventListener('resize', function () {
      var newAngle = window.screen && window.screen.orientation ? window.screen.orientation.angle : 0;
      if (newAngle !== _lastOrientAngle) {
        _lastOrientAngle = newAngle;
        fixedViewportHeight = window.innerHeight;
        calcH();
        _savedMaxT = maxT;
        if (currentT > 0) applyT(maxT, false);
      }
    });

    function applyT(y, animated) {
      // SÉCURITÉ DESKTOP : Si l'écran est large, on annule tout le comportement mobile
      if (window.innerWidth >= 750) {
        unified.style.transform = 'none';
        unified.style.transition = 'none';
        body.style.opacity = '1';
        body.style.visibility = 'visible';
        
        var miniInfo = document.getElementById('mp-mini-info');
        if (miniInfo) miniInfo.style.paddingTop = '20px';
        
        var btnWrap = document.getElementById('mp-mini-btn-wrap');
        if (btnWrap) btnWrap.style.display = 'none';

        var thumbsWrap = document.getElementById('mp-mini-thumbs-wrap');
        if (thumbsWrap) {
          thumbsWrap.style.display = 'none';
          thumbsWrap.style.opacity = '0';
        }
        return;
      }

      // Logique mobile d'origine (inchangée)
      unified.style.transition = animated ? 'transform 0.4s cubic-bezier(0.25,1,0.5,1)' : 'none';
      unified.style.transform  = 'translateY(' + y + 'px)';
      currentT = y;

      var prog = maxT > 0 ? 1 - (y / maxT) : 1;

      var thumbsWrap = document.getElementById('mp-mini-thumbs-wrap');
      if (thumbsWrap) {
        if (prog > 0.6) {
          thumbsWrap.style.maxHeight = '130px';
          thumbsWrap.style.opacity = '1';
          thumbsWrap.style.paddingTop = '14px';
          thumbsWrap.style.paddingBottom = '14px';
        } else {
          thumbsWrap.style.maxHeight = '0';
          thumbsWrap.style.opacity = '0';
          thumbsWrap.style.paddingTop = '0';
          thumbsWrap.style.paddingBottom = '0';
        }
      }

      var miniInfo = document.getElementById('mp-mini-info');
      if (miniInfo) miniInfo.style.paddingTop = (prog * 40) + 'px';

      body.style.opacity    = String(Math.max(0, (prog - 0.4) / 0.6));
      body.style.visibility = prog > 0.1 ? 'visible' : 'hidden';

      var btnWrap = document.getElementById('mp-mini-btn-wrap');
      if (btnWrap) {
        btnWrap.style.opacity       = String(Math.max(0, 1 - prog * 3));
        btnWrap.style.pointerEvents = prog > 0.3 ? 'none' : 'auto';
        btnWrap.style.height        = prog > 0.3 ? '0' : '';
        btnWrap.style.overflow      = prog > 0.3 ? 'hidden' : '';
      }
    }

    function snapOpen() {
  if (window.innerWidth >= 750) return;
  applyT(0, true);
  unified.style.paddingTop = '60px';
  document.body.style.overflow = 'hidden';
  window._mossenBodyLock = true;
  unified.classList.add('mp-is-open');

  // Overlay masquant tout l'arrière-plan
  if (!document.getElementById('mp-bg-overlay')) {
    var bg = document.createElement('div');
    bg.id = 'mp-bg-overlay';
    bg.style.cssText = 'position:fixed;inset:0;background:#fff;z-index:99999;';
    document.body.insertBefore(bg, document.body.firstChild);
  }
}
window.snapOpen = snapOpen;

    function snapClose() {
      unified.style.paddingTop = '';
      /* FIX POSITION : toujours utiliser _savedMaxT (mesuré à l'état propre) */
      if (_savedMaxT !== null) {
        maxT = _savedMaxT;
      } else {
        /* Fallback d'urgence — ne devrait jamais arriver */
        var miniInfo = document.getElementById('mp-mini-info');
        var btnWrap  = document.getElementById('mp-mini-btn-wrap');
        if (miniInfo) miniInfo.style.paddingTop = '0px';
        if (btnWrap) {
          btnWrap.style.height = '';
          btnWrap.style.overflow = '';
          btnWrap.style.opacity = '1';
          btnWrap.style.pointerEvents = 'auto';
        }
        calcH();
        _savedMaxT = maxT;
      }
      applyT(maxT, true);
  var bg = document.getElementById('mp-bg-overlay');
  if (bg) bg.remove();
  var scrollArea = document.getElementById('mp-scroll-area');
      if (scrollArea) scrollArea.scrollTop = 0; // Remet le contenu en haut
      document.body.style.overflow = '';
      window._mossenBodyLock = false;
      unified.classList.remove('mp-is-open');

      var list = document.getElementById('mp-size-list');
      var trig = document.getElementById('mp-size-trigger');
      var icon = document.getElementById('mp-size-icon');
      if (list) list.style.display = 'none';
      if (trig) trig.classList.remove('is-active');
      if (icon) icon.innerText = '+';
    }

    window.mossenCloseFull = snapClose;

    function getY(e) { return e.touches && e.touches.length ? e.touches[0].clientY : e.clientY; }

    function onStart(e) {
      if (window.innerWidth >= 750) return;
      // On empêche le "drag" si on touche les boutons ou les miniatures !
      if (e.target.closest('#mp-mini-btn-wrap') || e.target.closest('#mp-mini-thumbs-wrap') || e.target.closest('#mp-reassurance-rows')) return;
      
      if (_savedMaxT !== null) maxT = _savedMaxT; /* Toujours partir d'une base saine */
      startY = getY(e);
      startT = currentT;
      distY = 0;
      dragging = true;
      unified.style.transition = 'none';
      if (e.type !== 'mousedown') e.preventDefault();
    }

    function onMove(e) {
      if (!dragging) return;
      var moveY = getY(e);
      var diffY = moveY - startY; // Calcul de la distance du doigt
      distY = Math.abs(diffY);

      var isOpen = unified.classList.contains('mp-is-open');

      // --- LOGIQUE MOBILE : FORCE L'OUVERTURE ---
      // Si le panneau est fermé et que le doigt monte de plus de 5px
      if (!isOpen && diffY < -5) {
        dragging = false; 
        if (typeof window.snapOpen === 'function') {
          window.snapOpen();
        }
        return;
      }

      // Si le panneau est ouvert, on laisse le comportement de drag normal (vers le bas)
      var clamped = Math.max(0, Math.min(maxT, startT + diffY));
      applyT(clamped, false);
      
      // Empêche le rebond Safari/Chrome pendant qu'on manipule le panneau
      if (e.cancelable) e.preventDefault();
    }

    function onEnd() {
      if (!dragging) return;
      dragging = false;
      if (distY < 7) {
        if (currentT > maxT * 0.5) snapOpen();
        else snapClose();
      } else {
        if (currentT < maxT * 0.55) snapOpen();
        else snapClose();
      }
    }

    // Glissement depuis le trait noir
    header.addEventListener('touchstart', onStart, { passive: false });
    header.addEventListener('mousedown', onStart);
    
    // Glissement depuis le titre/prix
    var headerContent = document.getElementById('mp-header-content');
    if (headerContent) {
      headerContent.addEventListener('touchstart', onStart, { passive: false });
      headerContent.addEventListener('mousedown', onStart);
    }

    // Événements globaux
    document.addEventListener('touchmove',  onMove,  { passive: false });
    document.addEventListener('touchend',   onEnd);
    document.addEventListener('mousemove', onMove, { passive: false });
    document.addEventListener('mouseup',   onEnd);

    /* FIX SAC : le bouton mini appelle directement mossenDirectAdd pour les sacs */
    document.getElementById('mp-mini-btn').addEventListener('click', function () {
      if (isBag || !hasRealSizes) {
        mossenDirectAdd();
      } else {
        showSizePicker();
      }
    });

    /* ===================== RESTORE PANEL ===================== */
    window.mossenRestorePanel = function () {
      var unified = document.getElementById('mp-unified');
      if (unified && window.location.pathname.includes('/products/')) {
        unified.style.display = 'flex';
        if (_savedMaxT !== null) maxT = _savedMaxT;
        requestAnimationFrame(function () { applyT(maxT, true); });
      }
    };

    /* ===================== OBSERVER TIROIRS EXTERNES ===================== */
    var _externalObserver = new MutationObserver(function () {
      var unified = document.getElementById('mp-unified');
      if (!unified || !window.location.pathname.includes('/products/')) return;

      var externalLock =
        (document.body.style.overflow === 'hidden' ||
         document.body.classList.contains('overflow-hidden') ||
         document.documentElement.classList.contains('overflow-hidden')) &&
        !window._mossenBodyLock;

      if (externalLock) {
        unified.style.display = 'none';
      } else if (!externalLock && unified.style.display === 'none') {
        setTimeout(function () {
          if (window.mossenRestorePanel) window.mossenRestorePanel();
        }, 150);
      }
    });

    _externalObserver.observe(document.body, { attributes: true, attributeFilter: ['style', 'class'] });
    _externalObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  }

  window.mossenToggleSizeList = function () {
    var list = document.getElementById('mp-size-list');
    var trig = document.getElementById('mp-size-trigger');
    var icon = document.getElementById('mp-size-icon');
    if (!list) return;
    
    var open = list.style.display === 'block';
    list.style.display = open ? 'none' : 'block';
    
    if (trig) {
      if (open) {
        trig.classList.remove('is-active'); // Rentre la ligne
      } else {
        trig.classList.add('is-active'); // Sort la ligne
      }
    }
    
    if (icon) {
      icon.innerText = open ? '+' : '-'; // Change le symbole
    }
  };

  window.mossenSelectSize = function (i, btn) {
    document.querySelectorAll('.mp-size-item').forEach(function (b) { b.classList.remove('selected'); });
    btn.classList.add('selected');
    var s = window._mossenSizes[i];
    if (s && s.el) {
      if      (s.el.tagName === 'SELECT') { s.el.value = s.value; s.el.dispatchEvent(new Event('change', { bubbles: true })); }
      else if (s.el.tagName === 'INPUT')  { s.el.checked = true;  s.el.dispatchEvent(new Event('change', { bubbles: true })); }
      else s.el.click();
    }
    var lbl = document.getElementById('mp-size-label');
    if (lbl) lbl.innerHTML = 'Taille&nbsp;&nbsp;<strong>' + s.label + '</strong>';
    window._mossenSelectedSize = s.label;
    
    var list = document.getElementById('mp-size-list');
    var trig = document.getElementById('mp-size-trigger');
    var icon = document.getElementById('mp-size-icon');
    
    if (list) list.style.display = 'none';
    if (trig) trig.classList.remove('is-active');
    if (icon) icon.innerText = '+';
    
    var err = document.getElementById('mp-size-error');
    if (err) err.classList.remove('visible');
  };

  window.mossenAddToCart = function () {
  if (window._mossenHasRealSizes && !window._mossenSelectedSize) {
    var list = document.getElementById('mp-size-list');
    var trig = document.getElementById('mp-size-trigger');
    var icon = document.getElementById('mp-size-icon');
    if (list) list.style.display = 'block';
    if (trig) trig.classList.add('is-active');
    if (icon) icon.innerText = '-';
    var err = document.getElementById('mp-size-error');
    if (err) err.classList.add('visible');
    return;
  }
  window.mossenCloseFull();

  var variantId = document.querySelector('input[name="id"], select[name="id"]') ?
    document.querySelector('input[name="id"], select[name="id"]').value : null;

  if (variantId) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    }).then(function () {
      /* Attendre la fin de l'animation de fermeture (400ms),
         puis cacher complètement #mp-unified avant d'afficher la confirmation */
      setTimeout(function() {
        var unified = document.getElementById('mp-unified');
        if (unified) unified.style.display = 'none';
        showAddedPanel();
      }, 420);
    });
  } else {
    setTimeout(function() {
      var unified = document.getElementById('mp-unified');
      if (unified) unified.style.display = 'none';
      showAddedPanel();
    }, 520);
  }
};

  window.mossenDirectAdd = function () {
    var variantId = document.querySelector('input[name="id"], select[name="id"]') ?
      document.querySelector('input[name="id"], select[name="id"]').value : null;
    if (variantId) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      }).then(function () { setTimeout(showAddedPanel, 300); });
    } else {
      var btn = document.querySelector('.add-to-cart-button, button[name="add"]');
      if (btn) btn.click();
      setTimeout(showAddedPanel, 500);
    }
  };

  window.mossenToggleDirectAcc = function (btn) {
  var type = btn.getAttribute('data-type');
  var accBody = btn.nextElementSibling;
  var isOpen = accBody.style.display === 'block';

  // --- NOUVEAU : Animation de la ligne ---
  if (isOpen) {
    btn.classList.remove('is-active'); // On ferme l'accordéon = on rentre la ligne
  } else {
    btn.classList.add('is-active'); // On ouvre l'accordéon = on déploie la ligne
  }

  if (!isOpen && !accBody.innerHTML.trim()) {
    if (type === 'description') {
      var metaDesc = document.getElementById('mossen-meta-description');
      if (metaDesc && metaDesc.innerHTML.trim() !== '') {
        accBody.innerHTML = metaDesc.innerHTML;
      } else {
        var desc = document.querySelector('.product__description, [id*="description"] .rte');
        accBody.innerHTML = desc ? desc.innerHTML : 'Aucune description disponible.';
      }
    } else if (type === 'matiere') {
      var metaComp = document.getElementById('mossen-meta-composition');
      if (metaComp && metaComp.innerHTML.trim() !== '') {
        accBody.innerHTML = metaComp.innerHTML;
      } else {
        accBody.innerHTML = 'Composition non renseignée.';
      }
    } else if (type === 'livraison') {
      accBody.innerHTML = 
        '<div style="color:#111;">' +
          '<p style="font-size:11px;font-weight:700;letter-spacing:0.05em;margin:0 0 6px;">MODALITÉS DE LIVRAISON</p>' +
          '<p style="margin:0 0 16px;color:#555;line-height:1.5;"><strong>Livraison standard (Domicile ou Point Relais) : Sans frais</strong><br>Délai d\'acheminement estimé : 5 à 7 jours ouvrés.</p>' +
          '<p style="font-size:11px;font-weight:700;letter-spacing:0.05em;margin:0 0 6px;">ÉCHANGES ET RETOURS</p>' +
          '<p style="margin:0 0 12px;color:#555;line-height:1.5;">Une période de rétractation de 30 jours calendaires à compter de la date d\'expédition s\'applique pour toute demande d\'échange ou de remboursement.</p>' +
          '<p style="margin:0 0 10px;color:#555;line-height:1.5;"><strong>Échanges : Sans frais</strong><br>Le remplacement d\'un article est traité sans frais de port supplémentaires pour l\'utilisateur.</p>' +
          '<p style="margin:0 0 16px;color:#555;line-height:1.5;"><strong>Retours : Frais applicables</strong><br>Les frais d\'expédition associés au retour sont déduits du remboursement final. Ces frais sont intégralement pris en charge par nos services exclusivement en cas de non-conformité de la commande ou d\'article défectueux.</p>' +
          '<p style="margin:0;"><a href="/policies/refund-policy" style="color:#111;text-decoration:underline;">Consulter le règlement complet</a></p>' +
        '</div>';
    } else if (type === 'contact') {
      accBody.innerHTML = 
        '<p style="margin:0 0 16px; color:#111;"><strong>Support par courrier électronique :</strong> <a href="mailto:sav@maisonmossen.com" style="color:#111; text-decoration:none;">sav@maisonmossen.com</a><br><span style="color:#888;">Les requêtes sont traitées dans les meilleurs délais, du lundi au samedi.</span></p>' +
        '<div style="border-top:1px solid #f0f0f0; padding-top:16px;">' +
          '<p style="margin:0 0 12px; color:#111; font-family:Arial,sans-serif; font-size:12px; font-weight:700;">Soumettre une requête via le formulaire en ligne :</p>' +
          '<input type="text" id="mp-contact-name" placeholder="Votre prénom" style="width:100%; box-sizing:border-box; border:1px solid #e5e5e5; border-radius:2px; padding:10px 12px; margin-bottom:10px; font-family:Arial,sans-serif; font-size:12px; outline:none;">' +
          '<input type="email" id="mp-contact-email" placeholder="Votre adresse e-mail" style="width:100%; box-sizing:border-box; border:1px solid #e5e5e5; border-radius:2px; padding:10px 12px; margin-bottom:10px; font-family:Arial,sans-serif; font-size:12px; outline:none;">' +
          '<textarea id="mp-contact-msg" placeholder="Votre message..." rows="4" style="width:100%; box-sizing:border-box; border:1px solid #e5e5e5; border-radius:2px; padding:10px 12px; margin-bottom:12px; font-family:Arial,sans-serif; font-size:12px; outline:none; resize:none;"></textarea>' +
          '<p class="mp-contact-feedback" style="display:none; font-size:11px; margin-bottom:10px;"></p>' +
          '<button onclick="mossenSubmitInlineContact(this)" style="width:100%; background:#111; color:#fff; border:none; padding:12px; font-family:Arial,sans-serif; font-size:11px; letter-spacing:0.1em; text-transform:uppercase; cursor:pointer;">Envoyer</button>' +
        '</div>';
    }
  }
  
  accBody.style.display = isOpen ? 'none' : 'block';
};

window.mossenSubmitInlineContact = async function(btn) {
  const container = btn.parentElement;
  const name = container.querySelector('#mp-contact-name').value.trim();
  const email = container.querySelector('#mp-contact-email').value.trim();
  const msg = container.querySelector('#mp-contact-msg').value.trim();
  const feedback = container.querySelector('.mp-contact-feedback');

  if (!name || !email || !msg) {
    feedback.textContent = 'Veuillez remplir tous les champs.';
    feedback.style.color = '#e63946';
    feedback.style.display = 'block';
    return;
  }

  btn.textContent = 'ENVOI EN COURS...';
  btn.disabled = true;

  try {
    await fetch('/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: 'form_type=contact&utf8=%E2%9C%93&contact[name]=' + encodeURIComponent(name) + '&contact[email]=' + encodeURIComponent(email) + '&contact[body]=' + encodeURIComponent(msg)
    });
    
    container.innerHTML = '<p style="font-size:12px; color:#111; text-align:center; padding: 20px 0;">Merci ' + name + ', votre message a bien été envoyé. Nous vous répondrons dans les plus brefs délais.</p>';
  } catch(err) {
    feedback.textContent = 'Une erreur est survenue. Veuillez réessayer.';
    feedback.style.color = '#e63946';
    feedback.style.display = 'block';
    btn.textContent = 'ENVOYER';
    btn.disabled = false;
  }
};

  init();
});

/* ============================================================
   PANNEAU AJOUTÉ AU PANIER
   ============================================================ */
function showAddedPanel(manualData) {
  if (document.getElementById('mossen-added-panel')) return;

  var title        = manualData ? manualData.title : (document.querySelector('h1') ? document.querySelector('h1').innerText.trim() : '');
  var price        = manualData ? manualData.price : (document.querySelector('.price') ? document.querySelector('.price').innerText.trim() : '');
  var img          = manualData ? manualData.img   : (document.querySelector('.product-media-container img') ? document.querySelector('.product-media-container img').src : '');
  var selectedSize = window._mossenSelectedSize || (manualData ? manualData.size : '') || '';

  /* --- Création de l'arrière-plan cliquable --- */
  var overlay = document.createElement('div');
  overlay.id = 'mossen-added-overlay';
  overlay.style.opacity = '0';
  overlay.style.transition = 'opacity 0.4s ease';
  overlay.style.cursor = 'pointer'; // Indique à l'utilisateur qu'il peut cliquer
  
  // Fermer le panneau si on clique sur cet arrière-plan
  overlay.addEventListener('click', function() {
    mossenCloseAddedPanel();
  });
  document.body.appendChild(overlay);
  
  // Animation d'apparition fluide du fond
  setTimeout(function() { overlay.style.opacity = '1'; }, 10);

  /* --- Création du panneau à 70% --- */
  var panel = document.createElement('div');
  panel.id  = 'mossen-added-panel';
  /* 👇 max-height passe de 82vh à 70vh 👇 */
  panel.style.cssText = 'position:fixed; bottom:0; left:0; right:0; max-height:70vh; overflow-y:auto; -webkit-overflow-scrolling:touch; overscroll-behavior:contain; background:#fff; z-index:1000050; transform:translateY(100%); transition:transform 0.4s cubic-bezier(0.25,1,0.5,1); padding-bottom:40px; border-radius:16px 16px 0 0; box-shadow:0 -4px 30px rgba(0,0,0,0.08);';

  panel.innerHTML =
    /* Drag handle + bouton fermer */
    '<div id="mossen-drag-area" style="position:sticky; top:0; left:0; right:0; background:#fff; border-radius:16px 16px 0 0; z-index:100; padding:14px 0 10px; display:flex; justify-content:center; cursor:grab;">' +
      '<div style="width:36px; height:3px; background:#111; border-radius:2px;"></div>' +
    '</div>' +
    '<div style="padding:4px 20px 14px; display:flex; justify-content:space-between; align-items:center; border-bottom:1px solid #f0f0f0;">' +
      '<span style="font-family:Arial; font-size:10px; letter-spacing:0.15em; text-transform:uppercase; color:#111;">AJOUTÉ À VOTRE PANIER</span>' +
      '<a href="/cart" style="font-family:Arial; font-size:10px; letter-spacing:0.12em; text-transform:uppercase; color:#111; text-decoration:underline; text-underline-offset:3px;">Voir le panier</a>' +
    '</div>' +
    '<div style="padding:20px; display:flex; gap:16px; align-items:flex-start; border-bottom:1px solid #f5f5f5;">' +
      '<img src="' + img + '" style="width:80px; height:107px; object-fit:cover; border-radius:2px; flex-shrink:0;">' +
      '<div style="font-family:Arial; display:flex; flex-direction:column; gap:6px; padding-top:2px;">' +
        '<span style="font-size:12px; text-transform:uppercase; letter-spacing:0.05em; color:#111; line-height:1.4;">' + title + '</span>' +
        (selectedSize ? '<span style="font-size:11px; color:#888; letter-spacing:0.04em;">TAILLE ' + selectedSize + '</span>' : '') +
        '<span style="font-size:12px; color:#111;">' + price + '</span>' +
      '</div>' +
    '</div>' +
    '<div style="padding:20px 20px 0;">' +
      '<p style="font-family:Arial; font-size:10px; letter-spacing:0.15em; text-transform:uppercase; color:#111; margin:0 0 14px;">VOUS POURRIEZ ÊTRE INTÉRESSÉ</p>' +
      '<div id="mossen-reco-grid" style="display:grid; grid-template-columns:repeat(3,1fr); gap:8px; align-items:start;">' +
        '<div style="font-size:11px; color:#aaa; font-family:Arial;">Chargement...</div>' +
      '</div>' +
    '</div>';

  var mossChatHTML =
    '<div id="mp-moss-chat" style="margin-top:32px;border-top:1px solid #f0f0f0;padding-top:24px;">' +
      '<div id="mp-moss-messages" style="display:flex;flex-direction:column;gap:12px;margin-bottom:16px;min-height:0;"></div>' +
      '<div style="display:flex;flex-direction:column;align-items:center;gap:12px;">' +
        '<button onclick="mossenStartMossChat()" id="mp-moss-cta" style="background:none;border:none;cursor:pointer;padding:0;display:flex;align-items:center;gap:8px;font-family:Arial,sans-serif;font-size:13px;font-weight:400;color:#7c3aed;filter:drop-shadow(0 0 8px rgba(124,58,237,0.5));transition:filter 0.3s ease;">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="url(#mossGrad2)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
            '<defs><linearGradient id="mossGrad2" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stop-color="#ec4899"/><stop offset="100%" stop-color="#3b82f6"/></linearGradient></defs>' +
            '<path d="M12 2L14.8 9.2L22 12L14.8 14.8L12 22L9.2 14.8L2 12L9.2 9.2L12 2Z"/>' +
          '</svg>' +
          '<span style="background:linear-gradient(90deg,#7c3aed,#3b82f6);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;">Demander à Moss</span>' +
        '</button>' +
        '<div id="mp-moss-input-wrap" style="display:none;width:100%;box-sizing:border-box;">' +
          '<div style="display:flex;align-items:center;gap:10px;border:1px solid #e5e5e5;border-radius:50px;padding:8px 8px 8px 16px;background:#fafafa;">' +
            '<input id="mp-moss-input" type="text" placeholder="Posez votre question..." onkeydown="if(event.key===\'Enter\')mossenSendMossGuide()" style="flex:1;border:none;outline:none;font-family:Arial,sans-serif;font-size:13px;color:#111;background:transparent;">' +
            '<button onclick="mossenSendMossGuide()" style="background:#111;border:none;border-radius:50%;width:32px;height:32px;display:flex;align-items:center;justify-content:center;cursor:pointer;flex-shrink:0;">' +
              '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>' +
            '</button>' +
          '</div>' +
          '<p style="font-family:Arial,sans-serif;font-size:10px;color:#bbb;text-align:center;margin:8px 0 0;">Moss est une IA et peut se tromper.</p>' +
        '</div>' +
      '</div>' +
    '</div>';

  document.body.appendChild(panel);
  window._mpOriginalCells = null;
  window._mpCurrentUnit = 'cm';
  setTimeout(function () { panel.style.transform = 'translateY(0)'; }, 50);

/* --- Fermeture automatique après 3 secondes --- */
  /* --- Fermeture automatique après 3 secondes --- */
  var autoCloseTimer = setTimeout(function() {
    mossenCloseAddedPanel();
  }, 3000);

  panel.addEventListener('scroll', function() {
    clearTimeout(autoCloseTimer);
  }, { passive: true });

  /* --- Drag dynamique (Tactile + Souris) --- */
  var dragArea = panel.querySelector('#mossen-drag-area');
  var startY = 0;
  var currentY = 0;
  var isDragging = false;

  function onDragStart(e) {
    clearTimeout(autoCloseTimer); // Stoppe le chrono
    
    // Récupère la position Y (tactile ou souris)
    startY = e.type.includes('mouse') ? e.clientY : e.touches[0].clientY;
    
    // Permet le drag si on est tout en haut du panneau ou si on attrape le trait
    if (panel.scrollTop <= 0 || e.target.closest('#mossen-drag-area')) {
      isDragging = true;
      panel.style.transition = 'none'; // Suit le doigt/curseur en temps réel
      
      if (e.type === 'mousedown') {
        dragArea.style.cursor = 'grabbing';
        // Ajout des écouteurs globaux uniquement pendant le clic prolongé
        document.addEventListener('mousemove', onDragMove, { passive: false });
        document.addEventListener('mouseup', onDragEnd);
      }
    }
  }

  function onDragMove(e) {
    if (!isDragging) return;
    var moveY = e.type.includes('mouse') ? e.clientY : e.touches[0].clientY;
    var diffY = moveY - startY;
    
    // Permet de slider uniquement vers le bas
    if (diffY > 0) {
      currentY = diffY;
      panel.style.transform = 'translateY(' + currentY + 'px)';
      if (e.cancelable) e.preventDefault();
    }
  }

  function onDragEnd(e) {
    if (!isDragging) return;
    isDragging = false;
    dragArea.style.cursor = 'grab';
    
    // Rétablit l'animation fluide de relâchement
    panel.style.transition = 'transform 0.4s cubic-bezier(0.25,1,0.5,1)';
    
    // Si glissé de plus de 60px vers le bas -> fermeture
    if (currentY > 60) {
      mossenCloseAddedPanel();
    } else {
      panel.style.transform = 'translateY(0)';
    }
    currentY = 0;

    // Nettoyage des événements souris
    if (e.type.includes('mouse')) {
      document.removeEventListener('mousemove', onDragMove);
      document.removeEventListener('mouseup', onDragEnd);
    }
  }

  // Événements tactiles (sur tout le panneau)
  panel.addEventListener('touchstart', onDragStart, { passive: true });
  panel.addEventListener('touchmove', onDragMove, { passive: false });
  panel.addEventListener('touchend', onDragEnd, { passive: true });

  // Événements souris (uniquement si on attrape la zone du trait)
  dragArea.addEventListener('mousedown', onDragStart);

  /* Recommandations */
  fetch('/collections/mossen-s-jewels/products.json?limit=30')
    .then(function(r) { return r.json(); })
    .then(function(data) {
      var grid = document.getElementById('mossen-reco-grid');
      if (!grid) return;
      grid.innerHTML = '';
      data.products.forEach(function(p) {
        var src = p.images && p.images[0] ? p.images[0].src : '';
        var px  = p.variants[0] ? parseFloat(p.variants[0].price).toFixed(2).replace('.', ',') + ' €' : '';
        var a   = document.createElement('a');
        a.href  = '/products/' + p.handle;
        /* 👇 L'astuce magique est ici : on ajoute min-width: 0; */
        a.style.cssText = 'text-decoration:none; color:#111; display:block; min-width:0;';
        a.innerHTML =
  '<div style="position:relative; width:100%; padding-bottom:110%; overflow:hidden; background:#f5f5f5;">' +
    '<img src="' + src + '" style="position:absolute; top:0; left:0; width:100%; height:100%; object-fit:cover; object-position:top; display:block;">' +
  '</div>' +
  '<span style="font-size:9px; font-family:Arial; text-transform:uppercase; letter-spacing:0.02em; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; display:block; margin-top:5px; color:#111;">' + p.title + '</span>' +
  '<span style="font-size:9px; font-family:Arial; color:#888; display:block; margin-top:2px;">' + px + '</span>';
        grid.appendChild(a);
      });
    }).catch(function() {});
}

function mossenCloseAddedPanel() {
  var panel = document.getElementById('mossen-added-panel');
  var overlay = document.getElementById('mossen-added-overlay');
  
  if (panel) {
    // Fait descendre le panneau
    panel.style.transition = 'transform 0.35s cubic-bezier(0.25,1,0.5,1)';
    panel.style.transform = 'translateY(100%)';
    
    // Fait disparaître le fond en douceur
    if (overlay) {
      overlay.style.opacity = '0'; 
    }
    
    // Supprime définitivement les éléments du code après l'animation
    setTimeout(function() { 
      panel.remove(); 
      if (overlay) overlay.remove(); 
    }, 380);
  }
  
  if (window.mossenRestorePanel) window.mossenRestorePanel();
}

function showGuidePanel() {
  if (document.getElementById('mossen-guide-panel')) return;

  var panel = document.createElement('div');
  panel.id = 'mossen-guide-panel';
  panel.style.cssText = 'position:fixed;inset:0;background:#fff;z-index:2000030;overflow-y:auto;-webkit-overflow-scrolling:touch;overscroll-behavior:contain;touch-action:pan-y;font-family:Arial,sans-serif;';

  var data = { taille: 165, tailleUnit: 'cm', poids: 60, poidsUnit: 'kg', hanches: null, hanchesUnit: 'cm', tourTaille: null, tourTailleUnit: 'cm', fit: 'normal', step: 1 };
  var steps = 3;

  function recommander() {
    var tailleCm = data.tailleUnit === 'in' ? Math.round(data.taille * 2.54) : data.taille;
    var poidsKg = data.poidsUnit === 'lbs' ? Math.round(data.poids * 0.453) : data.poids;
    var imc = poidsKg / ((tailleCm / 100) * (tailleCm / 100));
    var bonus = 0;
    if (data.fit === 'ample') bonus += 1;
    if (data.fit === 'serre') bonus -= 1;
    if (data.hanches && data.tourTaille) {
      var hanchesRef = data.hanchesUnit === 'in' ? Math.round(data.hanches * 2.54) : data.hanches;
      var tailleRef = data.tourTailleUnit === 'in' ? Math.round(data.tourTaille * 2.54) : data.tourTaille;
      if (hanchesRef > 100) bonus += 1;
      if (hanchesRef > 110) bonus += 1;
      if (tailleRef > 85) bonus += 1;
    }
    var index = 0;
    if (imc < 17.5) index = 0;
    else if (imc < 19) index = 1;
    else if (imc < 21) index = 2;
    else if (imc < 23) index = 3;
    else if (imc < 25) index = 4;
    else if (imc < 27.5) index = 5;
    else if (imc < 30) index = 6;
    else index = 7;
    index = Math.max(0, Math.min(7, index + bonus));
    var tailles = [
      { t: 'XS',  fr: '34' },
      { t: 'S',   fr: '36' },
      { t: 'S',   fr: '38' },
      { t: 'M',   fr: '38-40' },
      { t: 'M',   fr: '40' },
      { t: 'L',   fr: '42' },
      { t: 'XL',  fr: '44' },
      { t: 'XXL', fr: '46' }
    ];
    return tailles[index];
  }

  function spinner(id, val) {
    return '<div style="display:flex;align-items:center;gap:0;border:1px solid #e5e5e5;overflow:hidden;border-radius:2px;width:fit-content;">' +
      '<button onclick="mossenGuideAdj(\'' + id + '\',-1)" style="width:48px;height:48px;background:#fff;border:none;cursor:pointer;font-size:20px;color:#888;display:flex;align-items:center;justify-content:center;">−</button>' +
      '<span style="width:64px;text-align:center;font-size:18px;color:#111;" id="gv-' + id + '">' + val + '</span>' +
      '<button onclick="mossenGuideAdj(\'' + id + '\',1)" style="width:48px;height:48px;background:#fff;border:none;cursor:pointer;font-size:20px;color:#888;display:flex;align-items:center;justify-content:center;">+</button>' +
    '</div>';
  }

  function unitBtn(id, current, opt1, opt2) {
    return '<div style="display:inline-flex;border:1px solid #e5e5e5;border-radius:2px;overflow:hidden;margin-left:12px;">' +
      '<button onclick="mossenGuideUnit(\'' + id + '\',\'' + opt1 + '\')" style="padding:8px 14px;font-size:10px;letter-spacing:0.08em;text-transform:uppercase;border:none;cursor:pointer;background:' + (current===opt1?'#111':'#fff') + ';color:' + (current===opt1?'#fff':'#888') + ';">' + opt1.toUpperCase() + '</button>' +
      '<button onclick="mossenGuideUnit(\'' + id + '\',\'' + opt2 + '\')" style="padding:8px 14px;font-size:10px;letter-spacing:0.08em;text-transform:uppercase;border:none;cursor:pointer;background:' + (current===opt2?'#111':'#fff') + ';color:' + (current===opt2?'#fff':'#888') + ';">' + opt2.toUpperCase() + '</button>' +
    '</div>';
  }

  function choixBtns(key, options) {
    return '<div style="display:flex;flex-direction:column;gap:8px;">' +
      options.map(function(o) {
        var active = data[key] === o.val;
        return '<button onclick="mossenGuideSet(\'' + key + '\',\'' + o.val + '\')" style="display:flex;align-items:center;justify-content:space-between;padding:16px;border:1px solid ' + (active?'#111':'#e5e5e5') + ';background:#fff;cursor:pointer;text-align:left;">' +
          '<div>' +
            '<span style="display:block;font-size:13px;font-weight:' + (active?'700':'400') + ';color:#111;">' + o.label + '</span>' +
            '<span style="display:block;font-size:11px;color:#aaa;margin-top:3px;">' + o.sub + '</span>' +
          '</div>' +
          '<div style="width:16px;height:16px;border-radius:50%;border:1px solid ' + (active?'#111':'#ccc') + ';display:flex;align-items:center;justify-content:center;flex-shrink:0;">' +
            (active ? '<div style="width:9px;height:9px;border-radius:50%;background:#111;"></div>' : '') +
          '</div>' +
        '</button>';
      }).join('') +
    '</div>';
  }

  function progressBar() {
    var pct = Math.round((data.step / steps) * 100);
    return '<div style="height:2px;background:#f0f0f0;margin:0 20px 28px;">' +
      '<div style="height:2px;background:#111;width:' + pct + '%;transition:width 0.3s ease;"></div>' +
    '</div>';
  }

  function backBtn() {
    return data.step > 1
      ? '<button onclick="mossenGuideStep(-1)" style="background:none;border:none;cursor:pointer;font-size:20px;color:#bbb;padding:0;line-height:1;">←</button>'
      : '<div style="width:24px;"></div>';
  }

  function render() {
    var content = '';
    var isLast = data.step === steps;
    var rec = recommander();

    if (data.step === 1) {
      content =
        '<p style="font-size:11px;letter-spacing:0.12em;text-transform:uppercase;color:#111;margin:0 0 20px;font-weight:700;">Vos mesures</p>' +
        '<p style="font-size:11px;letter-spacing:0.1em;text-transform:uppercase;color:#888;margin:0 0 10px;">Votre taille</p>' +
        '<div style="display:flex;align-items:center;margin-bottom:24px;">' + spinner('taille', data.taille) + unitBtn('taille', data.tailleUnit, 'cm', 'in') + '</div>' +
        '<p style="font-size:11px;letter-spacing:0.1em;text-transform:uppercase;color:#888;margin:0 0 10px;">Votre poids</p>' +
        '<div style="display:flex;align-items:center;margin-bottom:32px;">' + spinner('poids', data.poids) + unitBtn('poids', data.poidsUnit, 'kg', 'lbs') + '</div>' +
        '<p style="font-size:10px;color:#bbb;text-align:center;margin:0 0 24px;">Vos données restent sur votre appareil et ne sont pas enregistrées.</p>' +
        '<button onclick="mossenGuideStep(1)" style="display:block;width:100%;background:#111;color:#fff;border:none;padding:18px;font-size:11px;letter-spacing:0.15em;text-transform:uppercase;cursor:pointer;">Continuer</button>';

    } else if (data.step === 2) {
      content =
        '<p style="font-size:11px;letter-spacing:0.12em;text-transform:uppercase;color:#111;margin:0 0 6px;font-weight:700;">Vos mensurations</p>' +
        '<p style="font-size:11px;color:#aaa;margin:0 0 24px;">Facultatif — améliore la précision de la recommandation.</p>' +
        '<p style="font-size:11px;letter-spacing:0.1em;text-transform:uppercase;color:#888;margin:0 0 10px;">Tour de hanches</p>' +
        '<div style="display:flex;align-items:center;margin-bottom:24px;">' + spinner('hanches', data.hanches || 95) + unitBtn('hanches', data.hanchesUnit, 'cm', 'in') + '</div>' +
        '<p style="font-size:11px;letter-spacing:0.1em;text-transform:uppercase;color:#888;margin:0 0 10px;">Tour de taille</p>' +
        '<div style="display:flex;align-items:center;margin-bottom:28px;">' + spinner('tourTaille', data.tourTaille || 70) + unitBtn('tourTaille', data.tourTailleUnit, 'cm', 'in') + '</div>' +
        '<button onclick="mossenGuideStep(1)" style="display:block;width:100%;background:#111;color:#fff;border:none;padding:18px;font-size:11px;letter-spacing:0.15em;text-transform:uppercase;cursor:pointer;margin-bottom:10px;">Continuer</button>' +
        '<button onclick="mossenGuideStep(1)" style="display:block;width:100%;background:none;border:none;padding:14px;font-size:11px;letter-spacing:0.1em;text-transform:uppercase;color:#aaa;cursor:pointer;">Passer cette étape</button>';

    } else if (data.step === 3) {
      content =
        '<p style="font-size:11px;letter-spacing:0.12em;text-transform:uppercase;color:#111;margin:0 0 20px;font-weight:700;">Comment voulez-vous que l\'article taille ?</p>' +
        choixBtns('fit', [
          { val: 'serre',  label: 'Serré',      sub: 'Moulant, proche du corps' },
          { val: 'normal', label: 'À ma taille', sub: 'Coupe standard, ni trop serré ni trop ample' },
          { val: 'ample',  label: 'Ample',       sub: 'Loose, décontracté, confortable' }
        ]) +
        '<div style="background:#f9f9f9;padding:24px;text-align:center;margin-top:28px;margin-bottom:20px;">' +
          '<p style="font-size:10px;letter-spacing:0.15em;text-transform:uppercase;color:#888;margin:0 0 8px;">Taille recommandée</p>' +
          '<p style="font-size:46px;color:#111;margin:0 0 4px;font-weight:300;">' + rec.t + '</p>' +
          '<p style="font-size:11px;color:#aaa;margin:0;">Correspondance FR : ' + rec.fr + '</p>' +
        '</div>' +
        '<button onclick="mossenGuideApply()" style="display:block;width:100%;background:#111;color:#fff;border:none;padding:18px;font-size:11px;letter-spacing:0.15em;text-transform:uppercase;cursor:pointer;margin-bottom:10px;">Sélectionner — ' + rec.t + '</button>' +
        '<p style="font-size:10px;color:#bbb;text-align:center;margin:0;">Hésitation entre deux tailles ? Prenez la plus grande.</p>';
    }

    panel.innerHTML =
      '<div style="position:sticky;top:0;background:#fff;z-index:10;border-bottom:1px solid #f0f0f0;">' +
        '<div style="display:flex;justify-content:space-between;align-items:center;padding:18px 20px 16px;">' +
          backBtn() +
          '<span style="font-size:11px;letter-spacing:0.15em;text-transform:uppercase;color:#111;font-weight:700;">Trouver ma taille</span>' +
          '<button onclick="document.getElementById(\'mossen-guide-panel\').remove()" style="background:none;border:none;cursor:pointer;font-size:20px;color:#bbb;padding:0;line-height:1;">✕</button>' +
        '</div>' +
        progressBar() +
      '</div>' +
      '<div style="padding:8px 20px 60px;">' + content + '</div>';
  }

  window.mossenGuideStep = function(delta) {
    data.step = Math.max(1, Math.min(steps, data.step + delta));
    render();
    panel.scrollTop = 0;
  };

  window.mossenGuideAdj = function(id, delta) {
    var min = id === 'taille' ? 140 : id === 'poids' ? 30 : id === 'tourTaille' ? 50 : 60;
    var max = id === 'taille' ? 210 : id === 'poids' ? 200 : 160;
    var current = data[id] || (id === 'hanches' ? 95 : id === 'tourTaille' ? 70 : 0);
    data[id] = Math.max(min, Math.min(max, current + delta));
    var el = document.getElementById('gv-' + id);
    if (el) el.innerText = data[id];
  };

  window.mossenGuideUnit = function(id, unit) {
    if (id === 'taille' && data.tailleUnit !== unit) {
      data.taille = unit === 'in' ? Math.round(data.taille / 2.54) : Math.round(data.taille * 2.54);
      data.tailleUnit = unit;
    } else if (id === 'poids' && data.poidsUnit !== unit) {
      data.poids = unit === 'lbs' ? Math.round(data.poids * 2.205) : Math.round(data.poids / 2.205);
      data.poidsUnit = unit;
    } else if (id === 'hanches' && data.hanchesUnit !== unit) {
      data.hanches = data.hanches ? (unit === 'in' ? Math.round(data.hanches / 2.54) : Math.round(data.hanches * 2.54)) : null;
      data.hanchesUnit = unit;
    } else if (id === 'tourTaille' && data.tourTailleUnit !== unit) {
      data.tourTaille = data.tourTaille ? (unit === 'in' ? Math.round(data.tourTaille / 2.54) : Math.round(data.tourTaille * 2.54)) : null;
      data.tourTailleUnit = unit;
    }
    render();
  };

  window.mossenGuideSet = function(key, val) {
    data[key] = val;
    render();
  };

  window.mossenGuideApply = function() {
    var rec = recommander();
    var size = rec.t;
    document.querySelectorAll('.mp-size-item').forEach(function(btn) {
      if (btn.innerText.trim().toUpperCase() === size) btn.click();
    });
    document.querySelectorAll('.variant-option__button-label').forEach(function(lbl) {
      if (lbl.innerText.trim().toUpperCase() === size) lbl.click();
    });
    window._mossenSelectedSize = size;
    document.getElementById('mossen-guide-panel').remove();
    if (typeof window.snapOpen === 'function') window.snapOpen();
  };

  document.body.appendChild(panel);
  render();
}

/* ============================================================
   SÉLECTEUR DE TAILLE (PICKER)
   ============================================================ */
window.showSizePicker = function() {
  if (document.getElementById('mossen-size-picker')) return;

  // Article taille unique (accessoire) : ajout direct, pas de sélecteur
  if (!window._mossenHasRealSizes) {
    if (typeof window.mossenDirectAdd === 'function') window.mossenDirectAdd();
    return;
  }

  var picker = document.createElement('div');
  picker.id = 'mossen-size-picker';
  picker.style.cssText = 'position:fixed; inset:0; background:rgba(0,0,0,0.4); z-index:1000100; display:flex; align-items:flex-end;';

  var sizes = window._mossenSizes && window._mossenSizes.length > 0
              ? window._mossenSizes
              : [{label:'XS'}, {label:'S'}, {label:'M'}, {label:'L'}, {label:'XL'}];

  var sizesHTML = sizes.map(function(s, i) {
    return '<button onclick="mossenSelectFromPicker(\'' + s.label + '\', ' + i + ')" style="width:100%; padding:25px; background:none; border:none; border-bottom:1px solid #f9f9f9; font-size:14px; color:#111; cursor:pointer; text-align:center;"><span style="font-weight:400;">' + s.label + '</span></button>';
  }).join('');

  picker.innerHTML =
    '<div id="mossen-picker-content" style="width:100%; background:#fff; border-radius:20px 20px 0 0; padding:20px 0; transform:translateY(100%); transition:transform 0.3s ease-out; font-family:Arial, sans-serif;">' +
      '<div style="width:40px; height:4px; background:#e5e5e5; border-radius:2px; margin:0 auto 20px;"></div>' +
      '<div style="text-align:center; padding-bottom:15px; border-bottom:1px solid #f0f0f0;">' +
        '<span style="font-size:11px; letter-spacing:0.1em; text-transform:uppercase; font-weight:700;">Sélectionner une taille</span>' +
      '</div>' +
      '<div style="max-height:60vh; overflow-y:auto;">' + sizesHTML + '</div>' +
      '<button onclick="closeSizePicker(); showGuidePanel();" style="width:100%; padding:20px; background:none; border:none; font-size:11px; text-transform:uppercase; letter-spacing:0.1em; color:#888; cursor:pointer;">Guide des tailles</button>' +
    '</div>';

  picker.onclick = function(e) { if(e.target === picker) closeSizePicker(); };
  document.body.appendChild(picker);

  requestAnimationFrame(function() {
    document.getElementById('mossen-picker-content').style.transform = 'translateY(0)';
  });
};

window.mossenSelectFromPicker = function(label, index) {
  if (typeof window.mossenSelectSize === 'function') {
    var dummyBtn = document.createElement('button');
    window.mossenSelectSize(index, dummyBtn);
  }
  closeSizePicker();
  if (typeof window.mossenAddToCart === 'function') {
    window.mossenAddToCart();
  }
};

window.closeSizePicker = function() {
  var content = document.getElementById('mossen-picker-content');
  var picker  = document.getElementById('mossen-size-picker');
  if (content) content.style.transform = 'translateY(100%)';
  setTimeout(function() { if (picker) picker.remove(); }, 300);
};

window.addEventListener('popstate', function() {
  if (typeof mossenCloseFull === 'function') mossenCloseFull();
});


document.addEventListener('touchmove', function (e) {
  if (window._mossenBodyLock) {
    if (!e.target.closest('#mp-body') && 
        !e.target.closest('#mossen-added-panel') &&
        !e.target.closest('#mossen-guide-panel') &&
        !e.target.closest('#mp-guide-blanc') &&
        !e.target.closest('#mp-faq-panel') &&
        !e.target.closest('#mp-moss-panel') &&
        !e.target.closest('#mp-livraison-detail') &&
        !e.target.closest('#mp-scroll-area')) {
      e.preventDefault();
    }
  }
}, { passive: false });

(function autoOpenOnBottom() {
  function setup() {
    var sc = document.getElementById('scroll-container') || window;
    sc.addEventListener('scroll', function() {
      var element = sc === window ? document.documentElement : sc;
      var scrollTop = sc === window ? (window.pageYOffset || document.documentElement.scrollTop) : sc.scrollTop;
      var scrollingDown = scrollTop > (setup._last || 0);
      setup._last = Math.max(0, scrollTop);

      if (window._mossenBodyLock) return;
      if (document.getElementById('mossen-added-panel')) return;

      var scrollHeight = element.scrollHeight;
      var clientHeight = element.clientHeight;

      if (scrollingDown && (scrollTop + clientHeight >= scrollHeight - 5)) {
        if (window.snapOpen) window.snapOpen();
      }
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();

/* --- MAISON MOSSEN : GESTION DU SCROLL SOURIS (OUVERTURE & FERMETURE) --- */
window._mossenOverscrollUp = 0; // Compteur pour la marge de résistance

document.addEventListener('wheel', function(e) {
  if (window.innerWidth >= 750) return;
  var unified = document.getElementById('mp-unified');
  if (!unified) return;

  var isHoveringPanel = e.target.closest('#mp-unified');
  var isOpen = unified.classList.contains('mp-is-open');

  if (!isOpen && isHoveringPanel) {
    // 1. LE PANNEAU EST FERMÉ
    e.preventDefault();
    if (e.deltaY > 0 && typeof window.snapOpen === 'function') {
      window.snapOpen();
      window._mossenOverscrollUp = 0; // Réinitialise le compteur à l'ouverture
    }
  } 
  else if (isOpen) {
    // 2. LE PANNEAU EST OUVERT
    var scrollArea = document.getElementById('mp-scroll-area');
    
    if (scrollArea) {
      if (scrollArea.scrollTop > 0) {
        // Tant qu'on n'est pas tout en haut, le compteur reste à zéro
        window._mossenOverscrollUp = 0;
      } 
      else if (scrollArea.scrollTop <= 0 && e.deltaY < 0) {
        // On est en butée haute et on scrolle vers le haut : on accumule la force
        window._mossenOverscrollUp += e.deltaY;
        
        // Seuil de fermeture (ici -150 : il faut un vrai geste pour fermer)
        if (window._mossenOverscrollUp < -150) { 
          if (typeof window.mossenCloseFull === 'function') {
            window.mossenCloseFull();
          }
          window._mossenOverscrollUp = 0; // On vide le compteur après fermeture
        }
      }
    }
  }
}, { passive: false });

window.mossenSubmitNewsletter = function(btn) {
  var input = btn.previousElementSibling;
  var email = input ? input.value.trim() : '';
  if (!email) return;

  fetch('/contact', {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: 'form_type=customer&utf8=%E2%9C%93&contact[email]=' + encodeURIComponent(email) + '&contact[tags]=newsletter'
  }).then(function() {
    input.value = '';
    input.placeholder = 'Merci pour votre inscription !';
    input.style.color = '#888';
    btn.style.opacity = '0.3';
    btn.disabled = true;
  }).catch(function() {
    input.placeholder = 'Une erreur est survenue.';
  });
};

/* ============================================================
   FONCTION PREVIEW IMAGE (LIGHTBOX NETTE AVEC FLOU ET CROIX SUR L'IMAGE)
   ============================================================ */
window.mossenPreviewImg = function(src, event, idx) {
  if (event) { event.preventDefault(); event.stopPropagation(); }

  var imgs = window._mossenThumbImgs || [src];
  var current = idx !== undefined ? idx : imgs.indexOf(src);

  function render() {
    var overlay = document.getElementById('mossen-lightbox');
    if (!overlay) return;
    var hasPrev = current > 0;
    var hasNext = current < imgs.length - 1;

    overlay.innerHTML =
      '<div style="position:relative;width:auto;height:auto;display:flex;align-items:center;justify-content:center;max-width:80%;max-height:80vh;">' +
        '<img src="' + imgs[current] + '" style="width:100%;height:auto;object-fit:contain;border-radius:4px;box-shadow:0 15px 50px rgba(0,0,0,0.1);pointer-events:none;">' +
        '<button onclick="mossenClosePreview(event)" style="position:absolute;top:10px;right:10px;background:none;border:none;cursor:pointer;padding:10px;z-index:101;color:#111;">' +
          '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '</button>' +
        (hasPrev ? '<button onclick="window._mossenLbPrev(event)" style="position:absolute;left:-50px;top:50%;transform:translateY(-50%);background:rgba(255,255,255,0.85);border:none;border-radius:50%;width:40px;height:40px;font-size:22px;cursor:pointer;display:flex;align-items:center;justify-content:center;color:#111;">‹</button>' : '') +
        (hasNext ? '<button onclick="window._mossenLbNext(event)" style="position:absolute;right:-50px;top:50%;transform:translateY(-50%);background:rgba(255,255,255,0.85);border:none;border-radius:50%;width:40px;height:40px;font-size:22px;cursor:pointer;display:flex;align-items:center;justify-content:center;color:#111;">›</button>' : '') +
        '<span style="position:absolute;bottom:-28px;left:50%;transform:translateX(-50%);color:#fff;font-size:11px;font-family:Arial;letter-spacing:0.1em;">' + (current+1) + ' / ' + imgs.length + '</span>' +
      '</div>';
  }

  window._mossenLbPrev = function(e) { if(e) e.stopPropagation(); if(current > 0){ current--; render(); } };
  window._mossenLbNext = function(e) { if(e) e.stopPropagation(); if(current < imgs.length-1){ current++; render(); } };

  var existing = document.getElementById('mossen-lightbox');
  if (existing) existing.remove();

  var overlay = document.createElement('div');
  overlay.id = 'mossen-lightbox';
  overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.5);backdrop-filter:blur(10px);-webkit-backdrop-filter:blur(10px);z-index:2000000;display:flex;align-items:center;justify-content:center;opacity:0;transition:opacity 0.3s ease;cursor:zoom-out;';
  overlay.onclick = function(e) { if(e.target === overlay) mossenClosePreview(e); };
  document.body.appendChild(overlay);
  requestAnimationFrame(function() { overlay.style.opacity = '1'; });
  render();
};

window.mossenClosePreview = function(event) {
  if (event) event.stopPropagation();
  var overlay = document.getElementById('mossen-lightbox');
  if (overlay) {
    overlay.style.opacity = '0';
    setTimeout(function() { overlay.remove(); }, 300);
  }
};

/* ============================================================
   TIROIR DE RÉASSURANCE (TON PROFESSIONNEL & DESIGN HAUT)
   ============================================================ */
window.mossenOpenPolicy = function(type, event) {
  if (event) event.stopPropagation();

  // Contenu rédigé avec un ton institutionnel (Style Google Policy)
  var content = {
    livraison: {
      title: "LIVRAISON",
      url: "/policies/shipping-policy",
      body: "<strong>Traitement et acheminement des commandes</strong><br><br>" +
            "- <strong>Tarification :</strong> Maison Mossen prend en charge l'intégralité des frais de port (0,00 €). Aucun minimum de commande n'est requis.<br>" +
            "- <strong>Délais logistiques :</strong> Les commandes sont traitées par nos centres de distribution sous 24 à 48 heures ouvrées.<br>" +
            "- <strong>Acheminement standard :</strong> La livraison intervient dans un délai estimé de 5 à 7 jours ouvrés après expédition.<br>" +
            "- <strong>Traçabilité :</strong> Un identifiant de suivi unique est généré et transmis par voie électronique dès la remise du colis au transporteur."
    },
    echange: {
      title: "ÉCHANGES",
      url: "/policies/refund-policy",
      body: "<strong>Conditions de conformité et d'échange</strong><br><br>" +
            "- <strong>Éligibilité :</strong> Vous disposez d'une période de 30 jours calendaires à compter de la réception pour initier une demande d'échange.<br>" +
            "- <strong>Procédure de retour :</strong> Le service client émet une étiquette d'expédition prépayée permettant un retour sans frais pour le client.<br>" +
            "- <strong>Exigences relatives aux articles :</strong> Pour être éligible, le produit doit être retourné dans son état d'origine, incluant l'étiquetage intact et l'absence de signes d'usage.<br>" +
            "- <strong>Finalisation :</strong> L'article de remplacement est expédié de manière prioritaire dès validation de la conformité du retour."
    },
    retour: {
      title: "RETOURS",
      url: "/policies/refund-policy",
      body: "<strong>Droit de rétractation et remboursement</strong><br><br>" +
            "- <strong>Fenêtre de rétractation :</strong> Conformément à nos engagements, les retours sont autorisés dans un délai de 30 jours après livraison.<br>" +
            "- <strong>Modalités de remboursement :</strong> La transaction de remboursement est créditée automatiquement sur le mode de paiement initial.<br>" +
            "- <strong>Délais de traitement :</strong> Les fonds sont généralement débloqués sous 7 jours ouvrés après inspection de l'article retourné."
    }
  };

  var data = content[type];

  // 1. Overlay (Arrière-plan flou uniquement)
  var overlay = document.createElement('div');
  overlay.id = 'mp-policy-overlay';
  overlay.style.cssText = 'position:fixed; inset:0; background:none; backdrop-filter:blur(10px); -webkit-backdrop-filter:blur(10px); z-index:2000001; opacity:0; transition:opacity 0.3s ease;';
  
  // 2. Drawer (Titre placé très haut)
  var drawer = document.createElement('div');
  drawer.id = 'mp-policy-drawer';
  drawer.style.cssText = 'position:fixed; bottom:0; left:0; right:0; height:65vh; background:#fff; z-index:2000002; transform:translateY(100%); transition:transform 0.4s cubic-bezier(0.25, 1, 0.5, 1); border-radius:20px 20px 0 0; padding:20px 25px 45px; box-shadow:0 -10px 40px rgba(0,0,0,0.08); font-family: Arial, sans-serif;';
  
  drawer.innerHTML = 
    // Bouton Croix positionné précisément
    '<button onclick="mossenClosePolicy()" style="position:absolute; top:18px; right:20px; background:none; border:none; cursor:pointer; padding:5px; color:#111; z-index:10;">' +
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>' +
    '</button>' +
    // Titre Centré, Noir, Gras, placé plus haut
    '<h3 style="font-size:15px; margin: 0 0 30px; color:#111; font-weight:700; text-align:center; font-family:Arial, sans-serif; letter-spacing:0.08em; padding-top:5px;">' + data.title + '</h3>' +
    // Corps du texte formaté professionnellement
    '<div style="font-size:13px; line-height:1.7; color:#555; margin-bottom:30px; font-family:Arial, sans-serif;">' + data.body + '</div>' +
    // Lien Détails bleu discret
    '<a href="' + data.url + '" style="display:inline-block; color:#0066cc; text-decoration:underline; font-size:13px; font-family:Arial, sans-serif; font-weight:400;">En savoir plus sur nos conditions</a>';

  document.body.appendChild(overlay);
  document.body.appendChild(drawer);

  // 3. Animation d'ouverture
  requestAnimationFrame(function() {
    overlay.style.opacity = '1';
    drawer.style.transform = 'translateY(0)';
  });

  overlay.onclick = mossenClosePolicy;
};

window.mossenClosePolicy = function() {
  var overlay = document.getElementById('mp-policy-overlay');
  var drawer = document.getElementById('mp-policy-drawer');
  if (drawer) drawer.style.transform = 'translateY(100%)';
  if (overlay) overlay.style.opacity = '0';
  setTimeout(function() {
    if (overlay) overlay.remove();
    if (drawer) drawer.remove();
  }, 400);
};

window.mossenOpenFranceInfo = function(event) {
  if (event) event.stopPropagation();
  if (document.getElementById('mm-france-overlay')) return;

  var overlay = document.createElement('div');
  overlay.id = 'mm-france-overlay';
  overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.35);z-index:2000080;opacity:0;transition:opacity 0.25s ease;display:flex;align-items:center;justify-content:center;padding:20px;';
  overlay.onclick = function(e) { if (e.target === overlay) mossenCloseFranceInfo(); };

  var box = document.createElement('div');
  box.style.cssText = 'background:#fff;max-width:420px;width:100%;border-radius:14px;padding:28px 24px 24px;box-shadow:0 20px 60px rgba(0,0,0,0.18);transform:translateY(10px) scale(0.98);transition:transform 0.25s ease;font-family:Arial,sans-serif;position:relative;';
  box.innerHTML =
    '<button onclick="mossenCloseFranceInfo()" style="position:absolute;top:14px;right:14px;background:none;border:none;cursor:pointer;padding:4px;color:#999;line-height:1;">' +
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
    '</button>' +
    '<div style="display:flex;align-items:center;gap:8px;margin-bottom:16px;">' +
      '<svg width="20" height="20" viewBox="0 0 24 24" fill="none"><defs><linearGradient id="mm-fr-check-big" x1="0%" y1="0%" x2="100%" y2="0%"><stop offset="0%" stop-color="#0055A4"/><stop offset="50%" stop-color="#0055A4"/><stop offset="50%" stop-color="#EF4135"/><stop offset="100%" stop-color="#EF4135"/></linearGradient></defs><path d="M20 6L9 17l-5-5" stroke="url(#mm-fr-check-big)" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '<span style="font-size:14px;font-weight:700;color:#0a3d91;letter-spacing:0.02em;">Expédié depuis la France</span>' +
    '</div>' +
    '<p style="font-size:13px;line-height:1.7;color:#444;margin:0 0 14px;">La plupart de nos vêtements sont expédiés depuis notre atelier à Toulouse. Pour vous offrir la meilleure qualité, nous tenons à vérifier individuellement chacun de nos articles avant l\'envoi.</p>' +
    '<p style="font-size:13px;line-height:1.7;color:#444;margin:0;">Dans certains cas de rupture de stock, il se peut que l\'article ne soit pas expédié depuis la France : nous collaborons alors avec nos fournisseurs de confiance pour une expédition directe vers chez vous, dans les mêmes standards de qualité.</p>';

  overlay.appendChild(box);
  document.body.appendChild(overlay);
  requestAnimationFrame(function() {
    overlay.style.opacity = '1';
    box.style.transform = 'translateY(0) scale(1)';
  });
};

window.mossenCloseFranceInfo = function() {
  var overlay = document.getElementById('mm-france-overlay');
  if (!overlay) return;
  overlay.style.opacity = '0';
  setTimeout(function() { overlay.remove(); }, 250);
};

window.mossenOpenLivraisonDetail = function(event) {
  if (event) event.stopPropagation();
  if (document.getElementById('mp-livraison-detail')) return;
  var panel = document.createElement('div');
  panel.id = 'mp-livraison-detail';
  panel.style.cssText = 'position:fixed;inset:0;background:#fff;z-index:1000010;overflow-y:auto;-webkit-overflow-scrolling:touch;';
  panel.innerHTML =
    '<div style="position:sticky;top:0;background:#fff;z-index:10;border-bottom:1px solid #f0f0f0;display:flex;justify-content:space-between;align-items:center;padding:20px;">' +
      '<button onclick="document.getElementById(\'mp-livraison-detail\').remove()" style="background:none;border:none;cursor:pointer;padding:4px;display:flex;align-items:center;">' +
        '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#111" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>' +
      '</button>' +
      '<span style="font-family:Arial,sans-serif;font-size:11px;letter-spacing:0.15em;text-transform:uppercase;color:#111;font-weight:700;">Livraison</span>' +
      '<div style="width:30px;"></div>' +
    '</div>' +
    '<div style="padding:32px 20px 60px;">' +

      /* BLOC RÉSUMÉ */
      '<div style="background:#f9f9f9;padding:20px;margin-bottom:28px;">' +
        '<p style="font-family:Arial,sans-serif;font-size:11px;font-weight:700;letter-spacing:0.1em;text-transform:uppercase;color:#111;margin:0 0 4px;">Livraison express gratuite</p>' +
        '<p style="font-family:Arial,sans-serif;font-size:22px;font-weight:700;color:#111;margin:0 0 4px;">2 jours ouvrés</p>' +
        '<p style="font-family:Arial,sans-serif;font-size:13px;color:#555;margin:0;">Livraison estimée : <strong>' + (window._mossenDeliveryText || '') + '</strong></p>' +
      '</div>' +

      /* EXPÉDITION */
      '<div style="margin-bottom:28px;padding-bottom:28px;border-bottom:1px solid #f0f0f0;">' +
        '<p style="font-family:Arial,sans-serif;font-size:11px;font-weight:700;letter-spacing:0.12em;text-transform:uppercase;color:#111;margin:0 0 12px;">Expédition</p>' +
        '<div style="display:flex;flex-direction:column;gap:10px;">' +
          '<div style="display:flex;gap:12px;align-items:flex-start;">' +
            '<div style="width:6px;height:6px;border-radius:50%;background:#111;flex-shrink:0;margin-top:5px;"></div>' +
            '<p style="font-family:Arial,sans-serif;font-size:13px;color:#444;line-height:1.6;margin:0;">Votre commande est préparée et expédiée <strong>le jour même</strong> si elle est passée avant <strong style="color:#2a9d4e;">17h00</strong>, du lundi au samedi.</p>' +
          '</div>' +
          '<div style="display:flex;gap:12px;align-items:flex-start;">' +
            '<div style="width:6px;height:6px;border-radius:50%;background:#111;flex-shrink:0;margin-top:5px;"></div>' +
            '<p style="font-family:Arial,sans-serif;font-size:13px;color:#444;line-height:1.6;margin:0;">Les commandes passées après 17h ou le week-end sont expédiées le <strong>premier jour ouvré suivant</strong>.</p>' +
          '</div>' +
          '<div style="display:flex;gap:12px;align-items:flex-start;">' +
            '<div style="width:6px;height:6px;border-radius:50%;background:#111;flex-shrink:0;margin-top:5px;"></div>' +
            '<p style="font-family:Arial,sans-serif;font-size:13px;color:#444;line-height:1.6;margin:0;">Un email de confirmation avec votre <strong>numéro de suivi</strong> vous est envoyé dès la prise en charge par le transporteur.</p>' +
          '</div>' +
        '</div>' +
      '</div>' +

      /* TRANSPORTEUR */
      '<div style="margin-bottom:28px;padding-bottom:28px;border-bottom:1px solid #f0f0f0;">' +
        '<p style="font-family:Arial,sans-serif;font-size:11px;font-weight:700;letter-spacing:0.12em;text-transform:uppercase;color:#111;margin:0 0 12px;">Transporteur</p>' +
        '<div style="display:flex;align-items:center;gap:14px;">' +
          '<div style="width:48px;height:48px;border:1px solid #e5e5e5;display:flex;align-items:center;justify-content:center;flex-shrink:0;">' +
            '<svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#111" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>' +
          '</div>' +
          '<div>' +
            '<p style="font-family:Arial,sans-serif;font-size:13px;font-weight:700;color:#111;margin:0 0 3px;">Chronopost</p>' +
            '<p style="font-family:Arial,sans-serif;font-size:12px;color:#888;margin:0;">Livraison express J+1 à J+2 · Suivi en temps réel</p>' +
          '</div>' +
        '</div>' +
      '</div>' +

      /* EXPÉDIÉ DEPUIS LA FRANCE */
      '<div style="margin-bottom:28px;padding-bottom:28px;border-bottom:1px solid #f0f0f0;">' +
        '<p style="font-family:Arial,sans-serif;font-size:11px;font-weight:700;letter-spacing:0.12em;text-transform:uppercase;color:#111;margin:0 0 12px;">Origine d\'expédition</p>' +
        '<div style="display:flex;align-items:center;gap:10px;margin-bottom:10px;">' +
          '<svg width="18" height="18" viewBox="0 0 24 24" fill="none"><defs><linearGradient id="fr-det" x1="0%" y1="0%" x2="100%" y2="0%"><stop offset="0%" stop-color="#0055A4"/><stop offset="50%" stop-color="#0055A4"/><stop offset="50%" stop-color="#EF4135"/><stop offset="100%" stop-color="#EF4135"/></linearGradient></defs><path d="M20 6L9 17l-5-5" stroke="url(#fr-det)" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
          '<p style="font-family:Arial,sans-serif;font-size:13px;font-weight:700;color:#0a3d91;margin:0;">Expédié depuis la France — Toulouse</p>' +
        '</div>' +
        '<p style="font-family:Arial,sans-serif;font-size:13px;color:#444;line-height:1.6;margin:0;">Chaque sac est vérifié individuellement dans notre atelier toulousain avant expédition. Vous recevez un article contrôlé et soigneusement emballé.</p>' +
      '</div>' +

      /* DÉLAIS EXCEPTIONNELS */
      '<div style="margin-bottom:28px;padding-bottom:28px;border-bottom:1px solid #f0f0f0;">' +
        '<p style="font-family:Arial,sans-serif;font-size:11px;font-weight:700;letter-spacing:0.12em;text-transform:uppercase;color:#111;margin:0 0 12px;">Délais exceptionnels</p>' +
        '<p style="font-family:Arial,sans-serif;font-size:13px;color:#444;line-height:1.6;margin:0 0 10px;">La date de livraison estimée est donnée à titre indicatif. Des retards peuvent survenir dans les cas suivants :</p>' +
        '<div style="display:flex;flex-direction:column;gap:8px;">' +
          '<div style="display:flex;gap:10px;align-items:center;">' +
            '<span style="font-family:Arial,sans-serif;font-size:12px;color:#888;">—</span>' +
            '<span style="font-family:Arial,sans-serif;font-size:13px;color:#444;">Forte affluence (soldes, Black Friday, fêtes)</span>' +
          '</div>' +
          '<div style="display:flex;gap:10px;align-items:center;">' +
            '<span style="font-family:Arial,sans-serif;font-size:12px;color:#888;">—</span>' +
            '<span style="font-family:Arial,sans-serif;font-size:13px;color:#444;">Grèves des transporteurs ou services postaux</span>' +
          '</div>' +
          '<div style="display:flex;gap:10px;align-items:center;">' +
            '<span style="font-family:Arial,sans-serif;font-size:12px;color:#888;">—</span>' +
            '<span style="font-family:Arial,sans-serif;font-size:13px;color:#444;">Jours fériés nationaux</span>' +
          '</div>' +
          '<div style="display:flex;gap:10px;align-items:center;">' +
            '<span style="font-family:Arial,sans-serif;font-size:12px;color:#888;">—</span>' +
            '<span style="font-family:Arial,sans-serif;font-size:13px;color:#444;">Conditions météorologiques extrêmes</span>' +
          '</div>' +
        '</div>' +
      '</div>' +

      /* CONTACT */
      '<div style="background:#f9f9f9;padding:20px;">' +
        '<p style="font-family:Arial,sans-serif;font-size:12px;font-weight:700;color:#111;margin:0 0 6px;">Un problème avec votre livraison ?</p>' +
        '<p style="font-family:Arial,sans-serif;font-size:12px;color:#555;line-height:1.6;margin:0 0 12px;">Notre équipe est disponible du lundi au samedi de 9h à 18h30.</p>' +
        '<a href="mailto:sav@maisonmossen.com" style="display:block;font-family:Arial,sans-serif;font-size:12px;color:#111;text-decoration:underline;text-underline-offset:3px;margin-bottom:6px;">sav@maisonmossen.com</a>' +
      '</div>' +

    '</div>';
  document.body.appendChild(panel);
};

window.mossenOpenFAQ = function() {
  if (document.getElementById('mp-faq-panel')) return;
  var panel = document.createElement('div');
  panel.id = 'mp-faq-panel';
  panel.style.cssText = 'position:fixed;inset:0;background:#fff;z-index:1000010;overflow-y:auto;-webkit-overflow-scrolling:touch;';

  var faqs = [
    {
      q: "Ce sac est-il vraiment adapté pour aller en cours ?",
      a: "Oui, il a été conçu spécifiquement pour les étudiantes. Son compartiment principal est suffisamment grand pour accueillir jusqu'à 8 cahiers, un porte-vues, un classeur et un ordinateur portable 15 pouces. Tout ce dont vous avez besoin pour une journée de cours tient dans un seul sac."
    },
    {
      q: "Est-ce qu'un ordinateur portable rentre dedans ?",
      a: "Absolument. Le compartiment principal est conçu pour accueillir un ordinateur portable jusqu'à 15 pouces. Une poche intérieure rembourrée le maintient en place et le protège des chocs pendant le trajet."
    },
    {
      q: "Le sac est-il résistant à une utilisation quotidienne ?",
      a: "C'est précisément pour cela qu'il a été conçu. Les coutures sont renforcées aux points de tension, les anses sont doublées pour résister au poids et le cuir PU utilisé est traité pour résister à l'abrasion du quotidien. Il est pensé pour durer plusieurs années d'études."
    },
    {
      q: "Et en cas de pluie ? Est-il imperméable ?",
      a: "Le cuir PU dont est fabriqué ce sac présente une excellente résistance à l'eau. Une averse légère ou un passage sous la pluie ne l'abîmera pas. Pour une protection maximale par temps de forte pluie, nous recommandons l'utilisation d'un spray imperméabilisant."
    },
    {
      q: "Est-il lourd à porter quand il est chargé ?",
      a: "Malgré sa grande capacité, la structure du sac répartit le poids de façon équilibrée. Les anses larges et rembourrées réduisent la pression sur les mains et l'épaule. Beaucoup de nos clientes l'utilisent quotidiennement avec des cours chargés sans ressentir d'inconfort."
    },
    {
      q: "Combien de compartiments y a-t-il ?",
      a: "Le sac dispose d'un large compartiment principal pour vos affaires de cours, d'une poche avant zippée pour vos petits essentiels (clés, carte de transport, téléphone), et de poches intérieures pour organiser stylos, chargeur et câbles. Tout est à portée de main."
    },
    {
      q: "Quelle est la différence entre ce sac et un sac à dos ?",
      a: "Ce sac à main de cours combine l'élégance d'un sac cabas et la capacité d'un sac à dos. Il se porte à la main ou sur l'épaule, s'adapte aussi bien en amphi qu'en soirée, et ne vous donne pas l'air d'être en randonnée. C'est le compromis parfait entre style et fonctionnalité."
    },
    {
      q: "Je ne suis pas sûre de ma taille, puis-je l'échanger ?",
      a: "Bien sûr. Vous disposez de 30 jours à compter de la réception pour effectuer un échange ou un retour, sans avoir à vous justifier. L'échange est entièrement gratuit : nous vous envoyons une étiquette de retour prépayée et expédions le nouvel article dès réception du vôtre."
    },
    {
      q: "Et si le sac ne me convient pas à la réception ?",
      a: "Vous pouvez nous le retourner dans les 30 jours suivant la livraison. Dès réception et validation de l'article, nous procédons au remboursement intégral sur votre moyen de paiement d'origine, généralement sous 5 à 10 jours ouvrés."
    },
    {
      q: "Le sac sera-t-il livré rapidement ?",
      a: "Oui. Les sacs à main bénéficient de notre livraison express gratuite en 2 jours ouvrés. Votre commande est préparée et expédiée le jour même si vous commandez avant 17h, le lendemain matin sinon."
    },
    {
      q: "Comment entretenir ce sac pour qu'il dure longtemps ?",
      a: "Le cuir PU s'entretient très facilement. Essuyez-le avec un chiffon humide en cas de tache. Évitez de le laisser en plein soleil prolongé. Rangez-le à plat ou rembourré pour qu'il conserve sa forme. Un entretien minimal suffit pour le garder en parfait état pendant des années."
    }
  ];

  var faqHTML = faqs.map(function(item, i) {
    return '<div style="border-bottom:1px solid #f0f0f0;">' +
      '<button onclick="mossenToggleFAQ(' + i + ')" id="mp-faq-btn-' + i + '" style="width:100%;display:flex;justify-content:space-between;align-items:center;padding:18px 0;background:none;border:none;cursor:pointer;text-align:left;gap:16px;">' +
        '<span style="font-family:Arial,sans-serif;font-size:13px;color:#111;font-weight:600;line-height:1.4;">' + item.q + '</span>' +
        '<svg id="mp-faq-arrow-' + i + '" width="12" height="7" viewBox="0 0 12 7" fill="none" stroke="#111" stroke-width="1.5" style="flex-shrink:0;transition:transform 0.3s;"><path d="M1 1l5 5 5-5"/></svg>' +
      '</button>' +
      '<div id="mp-faq-body-' + i + '" style="display:none;padding:0 0 18px;">' +
        '<p style="font-family:Arial,sans-serif;font-size:13px;color:#555;line-height:1.7;margin:0;">' + item.a + '</p>' +
      '</div>' +
    '</div>';
  }).join('');

  panel.innerHTML =
    '<div style="position:sticky;top:0;background:#fff;z-index:10;border-bottom:1px solid #f0f0f0;display:flex;justify-content:space-between;align-items:center;padding:20px;">' +
      '<button onclick="document.getElementById(\'mp-faq-panel\').remove()" style="background:none;border:none;cursor:pointer;padding:4px;display:flex;align-items:center;">' +
        '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#111" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>' +
      '</button>' +
      '<span style="font-family:Arial,sans-serif;font-size:11px;letter-spacing:0.15em;text-transform:uppercase;color:#111;font-weight:700;">Questions fréquentes</span>' +
      '<div style="width:30px;"></div>' +
    '</div>' +
    '<div style="padding:8px 20px 60px;">' +
      faqHTML +
      '<div style="margin-top:32px;padding:20px;background:#f9f9f9;">' +
        '<p style="font-family:Arial,sans-serif;font-size:12px;color:#111;font-weight:700;margin:0 0 10px;">Vous n\'avez pas trouvé votre réponse ?</p>' +
        '<button onclick="document.getElementById(\'mp-faq-panel\').remove();mossenOpenMossPanel();" style="background:none;border:none;padding:0;cursor:pointer;display:flex;align-items:center;gap:8px;margin-bottom:16px;">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><defs><linearGradient id="mossGradFAQ" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stop-color="#ec4899"/><stop offset="100%" stop-color="#3b82f6"/></linearGradient></defs><path d="M12 2L14.8 9.2L22 12L14.8 14.8L12 22L9.2 14.8L2 12L9.2 9.2L12 2Z" stroke="url(#mossGradFAQ)"/></svg>' +
          '<span style="font-family:Arial,sans-serif;font-size:12px;background:linear-gradient(90deg,#7c3aed,#3b82f6);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;font-weight:600;">Demandez à Moss AI</span>' +
        '</button>' +
        '<p style="font-family:Arial,sans-serif;font-size:12px;color:#555;margin:0 0 10px;line-height:1.6;">Notre équipe répond à toutes vos questions du lundi au samedi de 9h à 18h30.</p>' +
        '<a href="mailto:sav@maisonmossen.com" style="display:block;font-family:Arial,sans-serif;font-size:12px;color:#111;text-decoration:underline;text-underline-offset:3px;margin-bottom:6px;">sav@maisonmossen.com</a>' +
      '</div>' +
    '</div>';

  document.body.appendChild(panel);

  window.mossenToggleFAQ = function(i) {
    var body = document.getElementById('mp-faq-body-' + i);
    var arrow = document.getElementById('mp-faq-arrow-' + i);
    var isOpen = body.style.display === 'block';
    body.style.display = isOpen ? 'none' : 'block';
    if (arrow) arrow.style.transform = isOpen ? 'rotate(0deg)' : 'rotate(180deg)';
  };
};

window.mossenOpenMossPanel = function() {
  if (document.getElementById('mp-moss-panel')) return;
  var panel = document.createElement('div');
  panel.id = 'mp-moss-panel';
  panel.style.cssText = 'position:fixed;inset:0;background:#fff;z-index:1000010;overflow-y:auto;-webkit-overflow-scrolling:touch;display:flex;flex-direction:column;';
  panel.innerHTML =
    '<div style="position:sticky;top:0;background:#fff;z-index:10;border-bottom:1px solid #f0f0f0;display:flex;justify-content:space-between;align-items:center;padding:20px;">' +
      '<button onclick="document.getElementById(\'mp-moss-panel\').remove()" style="background:none;border:none;cursor:pointer;padding:4px;display:flex;align-items:center;">' +
        '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#111" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>' +
      '</button>' +
      '<span style="font-family:Arial,sans-serif;font-size:11px;letter-spacing:0.15em;text-transform:uppercase;color:#111;font-weight:700;">Moss AI</span>' +
      '<div style="width:30px;"></div>' +
    '</div>' +
    '<div style="flex:1;display:flex;flex-direction:column;padding:20px;">' +
      '<div id="mp-moss-panel-messages" style="flex:1;display:flex;flex-direction:column;gap:12px;margin-bottom:16px;">' +
        '<div style="display:flex;align-items:flex-start;gap:8px;">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" style="flex-shrink:0;margin-top:3px;"><defs><linearGradient id="mossGradPanel" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stop-color="#ec4899"/><stop offset="100%" stop-color="#3b82f6"/></linearGradient></defs><path d="M12 2L14.8 9.2L22 12L14.8 14.8L12 22L9.2 14.8L2 12L9.2 9.2L12 2Z" stroke="url(#mossGradPanel)"/></svg>' +
          '<span style="font-family:Arial,sans-serif;font-size:13px;color:#111;line-height:1.7;">Bonjour ! Je suis Moss, l\'assistante IA de Maison Mossen. Posez-moi toutes vos questions sur ce sac, la livraison, les retours ou nos produits.</span>' +
        '</div>' +
      '</div>' +
      '<div style="border:1px solid #e5e5e5;border-radius:50px;padding:8px 8px 8px 16px;display:flex;align-items:center;gap:10px;background:#fafafa;">' +
        '<input id="mp-moss-panel-input" type="text" placeholder="Posez votre question..." onkeydown="if(event.key===\'Enter\')mossenSendMossPanel()" style="flex:1;border:none;outline:none;font-family:Arial,sans-serif;font-size:13px;color:#111;background:transparent;">' +
        '<button onclick="mossenSendMossPanel()" style="background:#111;border:none;border-radius:50%;width:32px;height:32px;display:flex;align-items:center;justify-content:center;cursor:pointer;flex-shrink:0;">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>' +
        '</button>' +
      '</div>' +
      '<p style="font-family:Arial,sans-serif;font-size:10px;color:#bbb;text-align:center;margin:8px 0 0;">Moss est une IA et peut se tromper.</p>' +
    '</div>';

  document.body.appendChild(panel);
  setTimeout(function() { document.getElementById('mp-moss-panel-input').focus(); }, 300);

  window.mossenSendMossPanel = async function() {
    var input = document.getElementById('mp-moss-panel-input');
    var messages = document.getElementById('mp-moss-panel-messages');
    var text = input ? input.value.trim() : '';
    if (!text) return;
    input.value = '';

    var userBubble = document.createElement('div');
    userBubble.style.cssText = 'display:flex;justify-content:flex-end;';
    userBubble.innerHTML = '<span style="background:rgba(0,0,0,0.06);color:#111;border-radius:18px 18px 4px 18px;padding:9px 14px;font-size:12px;font-family:Arial,sans-serif;max-width:80%;line-height:1.6;">' + text + '</span>';
    messages.appendChild(userBubble);

    var botBubble = document.createElement('div');
    botBubble.style.cssText = 'display:flex;align-items:flex-start;gap:8px;';
    botBubble.innerHTML =
      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" style="flex-shrink:0;margin-top:3px;"><defs><linearGradient id="mossGradReply" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stop-color="#ec4899"/><stop offset="100%" stop-color="#3b82f6"/></linearGradient></defs><path d="M12 2L14.8 9.2L22 12L14.8 14.8L12 22L9.2 14.8L2 12L9.2 9.2L12 2Z" stroke="url(#mossGradReply)"/></svg>' +
      '<span id="mp-moss-panel-reply" style="font-size:12px;font-family:Arial,sans-serif;color:#bbb;line-height:1.7;max-width:85%;">Moss réfléchit...</span>';
    messages.appendChild(botBubble);
    messages.scrollTop = messages.scrollHeight;

    try {
      var res = await fetch('https://mossen-marketing-3eyv.vercel.app/api/shopify-chat', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ message: text })
      });
      var data = await res.json();
      var answer = data.answer || 'Je n\'ai pas pu répondre. Contactez-nous à sav@maisonmossen.com';
      var replyEl = botBubble.querySelector('#mp-moss-panel-reply');
      replyEl.style.color = '#111';
      replyEl.textContent = '';
      var words = answer.split(' ');
      var i = 0;
      var iv = setInterval(function() {
        if (i < words.length) { replyEl.textContent += (i === 0 ? '' : ' ') + words[i]; i++; messages.scrollTop = messages.scrollHeight; }
        else clearInterval(iv);
      }, 35);
    } catch(e) {
      botBubble.querySelector('#mp-moss-panel-reply').textContent = 'Une erreur est survenue. Contactez-nous à sav@maisonmossen.com';
    }
  };
};

window.mossenOpenDimensions = function() {
  if (document.getElementById('mp-capacite-panel')) return;
  var panel = document.createElement('div');
  panel.id = 'mp-capacite-panel';
  panel.style.cssText = 'position:fixed;inset:0;background:#fff;z-index:1000010;overflow-y:auto;-webkit-overflow-scrolling:touch;';

  var handle = window.location.pathname.split('/').pop();
  var catalogueSacs = {
    "sac-a-main-en-cuir-pu-maison-mossen-1":   { largeur: "39 cm", hauteur: "30 cm", profondeur: "16 cm" },
    "sac-a-main-maison-mossen-en-cuir-pu":     { largeur: "34 cm", hauteur: "26 cm", profondeur: "15 cm" },
    "sac-a-main-en-cuir-pu-maison-mossen-10":  { largeur: "59 cm", hauteur: "31 cm", profondeur: "—" },
    "sac-a-main-pour-les-cours-en-cuir-pu-5":  { largeur: "40 cm", hauteur: "25 cm", profondeur: "15 cm" },
    "sac-a-main-pour-les-cours-en-cuir-pu-4":  { largeur: "39 cm", hauteur: "30 cm", profondeur: "16 cm" },
    "sac-a-main-maison-mossen-en-cuir-pu-14":  { largeur: "39 cm", hauteur: "30 cm", profondeur: "16 cm" },
    "sac-a-main-maison-mossen-en-cuir-pu-1":   { largeur: "40 cm", hauteur: "29 cm", profondeur: "14 cm" },
    "sac-a-main-en-cuir-brosse-maison-mossen": { largeur: "39 cm", hauteur: "30 cm", profondeur: "16 cm" },
    "sac-a-main-en-cuir-pu-1":                 { largeur: "39 cm", hauteur: "30 cm", profondeur: "16 cm" },
    "sac-a-main-en-cuir-pu-teckel":            { largeur: "39 cm", hauteur: "30 cm", profondeur: "16 cm" }
  };
  var dim = catalogueSacs[handle] || { largeur: "—", hauteur: "—", profondeur: "—" };

  panel.innerHTML =
    '<div style="position:sticky;top:0;background:#fff;z-index:10;border-bottom:1px solid #f0f0f0;display:flex;justify-content:space-between;align-items:center;padding:20px;">' +
      '<button onclick="document.getElementById(\'mp-capacite-panel\').remove()" style="background:none;border:none;cursor:pointer;padding:4px;display:flex;align-items:center;">' +
        '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#111" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>' +
      '</button>' +
      '<span style="font-family:Arial,sans-serif;font-size:11px;letter-spacing:0.15em;text-transform:uppercase;color:#111;font-weight:700;">Capacité de rangement</span>' +
      '<div style="width:30px;"></div>' +
    '</div>' +
    '<div style="padding:40px 20px 60px;">' +

      '<div style="position:relative;width:100%;max-width:380px;margin:0 auto 60px;">' +
        '<img src="https://cdn.shopify.com/s/files/1/0752/4230/7850/files/saccroquis.png?v=1781188437" style="width:100%;display:block;">' +

        /* FLÈCHE HAUTEUR — gauche verticale */
        '<div style="position:absolute;left:2%;top:18%;height:60%;display:flex;flex-direction:column;align-items:center;gap:0;">' +
          '<div style="border-left:4px solid transparent;border-right:4px solid transparent;border-bottom:8px solid #111;"></div>' +
          '<div style="width:2px;flex:1;background:#111;"></div>' +
          '<div style="border-left:4px solid transparent;border-right:4px solid transparent;border-top:8px solid #111;"></div>' +
        '</div>' +
        '<div style="position:absolute;left:1%;top:50%;transform:translateY(-50%);display:flex;flex-direction:column;align-items:center;gap:2px;margin-left:-2px;">' +
          '<span style="font-family:Arial,sans-serif;font-size:11px;font-weight:700;color:#111;white-space:nowrap;writing-mode:vertical-rl;text-orientation:mixed;transform:rotate(180deg);">Hauteur · ' + dim.hauteur + '</span>' +
        '</div>' +

        /* FLÈCHE LARGEUR — bas horizontale */
        '<div style="position:absolute;bottom:-28px;left:8%;right:8%;display:flex;align-items:center;gap:0;">' +
          '<div style="border-top:4px solid transparent;border-bottom:4px solid transparent;border-right:8px solid #111;"></div>' +
          '<div style="height:2px;flex:1;background:#111;"></div>' +
          '<div style="border-top:4px solid transparent;border-bottom:4px solid transparent;border-left:8px solid #111;"></div>' +
        '</div>' +
        '<div style="position:absolute;bottom:-46px;left:50%;transform:translateX(-50%);white-space:nowrap;">' +
          '<span style="font-family:Arial,sans-serif;font-size:11px;font-weight:700;color:#111;">Largeur · ' + dim.largeur + '</span>' +
        '</div>' +

        /* FLÈCHE PROFONDEUR — bas gauche verticale */
        '<div style="position:absolute;left:14%;bottom:4%;height:28%;display:flex;flex-direction:column;align-items:center;gap:0;">' +
          '<div style="border-left:4px solid transparent;border-right:4px solid transparent;border-bottom:8px solid #555;"></div>' +
          '<div style="width:2px;flex:1;background:#555;stroke-dasharray:4,3;border-left:2px dashed #555;background:none;"></div>' +
          '<div style="border-left:4px solid transparent;border-right:4px solid transparent;border-top:8px solid #555;"></div>' +
        '</div>' +
        '<div style="position:absolute;left:8%;bottom:32%;white-space:nowrap;">' +
          '<span style="font-family:Arial,sans-serif;font-size:11px;font-weight:700;color:#555;">Prof. · ' + dim.profondeur + '</span>' +
        '</div>' +

      '</div>' +

    '</div>';

  document.body.appendChild(panel);
};

/* ============================================================
   NAVIGATION COLLECTIONS (style Prada)
   ============================================================ */
document.addEventListener('DOMContentLoaded', function() {
  if (!window.location.pathname.includes('/collections/')) return;

  var collections = [
    { label: 'Tout voir',          url: '/collections/all' },
    { label: 'Nouveautés',         url: '/collections/nouveautes' },
    { label: 'Sacs',               url: '/collections/sac-a-main' },
    { label: 'Vestes',             url: '/collections/vestes-et-manteaux' },
    { label: 'Blazers',            url: '/collections/blazer' },
    { label: 'Pulls | Gilets',     url: '/collections/hauts' },
    { label: 'Manteaux | Trench',  url: '/collections/vestes-et-manteaux' },
    { label: 'Chemises',           url: '/collections/chemises' },
    { label: 'Maille',             url: '/collections/hauts' },
    { label: 'Pantalons',          url: '/collections/pantalons' },
    { label: 'Jeans',              url: '/collections/pantalons' },
    { label: 'Sweats | Jogging',   url: '/collections/hauts' },
    { label: 'T-shirts',           url: '/collections/t-shirts' },
    { label: 'Tops | Bodys',       url: '/collections/tops' },
    { label: 'Ensembles',          url: '/collections/ensemble' },
    { label: 'Robes',              url: '/collections/robes' },
    { label: 'Jupes',              url: '/collections/jupes-shorts' },
    { label: 'Bermudas',           url: '/collections/shorts' },
    { label: 'Cuir',               url: '/collections/vestes-et-manteaux' },
    { label: 'Chaussures',         url: '/collections/chaussures-cie' },
    { label: 'Accessoires',        url: '/collections/mossen-s-jewels' },
    { label: 'Bijoux',             url: '/collections/mossen-s-jewels' },
    { label: 'Parfums',            url: '/collections/parfums' },
    { label: 'Maquillage',         url: '/collections/beaute' }
  ];

  var currentPath = window.location.pathname.replace(/\/$/, '');

  var nav = document.createElement('div');
  nav.id = 'mossen-collection-nav';
  nav.style.cssText = 'position:fixed;left:0;right:0;z-index:99998;background:#fff;border-bottom:1px solid #f0f0f0;transition:top 0.3s ease;';

  nav.innerHTML =
    '<div style="display:flex;overflow-x:auto;gap:0;padding:8px 20px 0;scrollbar-width:none;-webkit-overflow-scrolling:touch;white-space:nowrap;">' +
    collections.map(function(col, idx) {
      var colPath = col.url.replace(/\/$/, '');
      /* Plusieurs onglets partagent une collection : seul le premier est souligné */
      var firstIdx = collections.findIndex(function(c) { return c.url.replace(/\/$/, '') === currentPath; });
      var isActive = idx === firstIdx;
      return '<a href="' + col.url + '" style="' +
        'flex-shrink:0;text-decoration:none;font-family:Arial,sans-serif;font-size:12px;' +
        'letter-spacing:0.04em;color:' + (isActive ? '#111' : '#999') + ';' +
        'font-weight:' + (isActive ? '700' : '400') + ';' +
        'padding-right:20px;padding-bottom:4px;display:inline-flex;flex-direction:column;align-items:center;gap:3px;' +
        '">' + col.label +
        '<span style="display:block;height:2px;width:100%;background:' + (isActive ? '#111' : 'transparent') + ';"></span>' +
        '</a>';
    }).join('') +
    '</div>';

  var style = document.createElement('style');
  style.textContent = '#mossen-collection-nav div::-webkit-scrollbar{display:none;}';
  document.head.appendChild(style);

  document.body.appendChild(nav);

  // Positionne sous le header et ajuste le scroll-container
  function positionNav() {
    var headerH = 60;
    nav.style.top = headerH + 'px';
    // On ajuste uniquement le MainContent qui a déjà le padding du header
    var main = document.getElementById('MainContent');
    if (main) main.style.setProperty('padding-top', (headerH + nav.offsetHeight) + 'px', 'important');
  }

  setTimeout(positionNav, 150);

  // Écoute directement sur #scroll-container
  var scrollContainer = document.getElementById('scroll-container');
  if (scrollContainer) {
    scrollContainer.addEventListener('scroll', function() {
      var headerH = 60;
      if (scrollContainer.scrollTop > 10) {
        nav.style.top = '-' + nav.offsetHeight + 'px';
      } else {
        nav.style.top = headerH + 'px';
      }
    }, { passive: true });
  }
  // Bouton vue 1 colonne / 2 colonnes
  setTimeout(function() {
    var singleBtn = document.querySelector('[data-grid-cols="1"], .collection-view-btn--single, button[aria-label*="1"], .icon-view-single')?.closest('button');
    
    // On cherche les boutons de vue grille nativement
    var viewBtns = document.querySelectorAll('[data-grid], [data-view], .collection__view-btn, .collection-filters__view-btn');
    
    viewBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var grid = document.querySelector('.product-grid, ul.product-grid');
        if (!grid) return;
        var isOne = btn.getAttribute('data-grid') === '1' || btn.querySelector('svg rect:only-child') || btn.classList.contains('active');
        if (isOne) {
          grid.style.gridTemplateColumns = '1fr';
          grid.querySelectorAll('li').forEach(function(li) {
            li.style.gridColumn = 'span 1';
          });
        } else {
          grid.style.gridTemplateColumns = '1fr 1fr';
          grid.querySelectorAll('li').forEach(function(li) {
            li.style.gridColumn = '';
          });
        }
      });
    });

    // Fallback : on intercepte tous les clics sur les boutons de vue
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-grid], [data-view], .collection__view-btn');
      if (!btn) return;
      var grid = document.querySelector('.product-grid, ul.product-grid');
      if (!grid) return;
      var val = btn.getAttribute('data-grid') || btn.getAttribute('data-view');
      if (val === '1') {
        grid.style.setProperty('grid-template-columns', '1fr', 'important');
        grid.querySelectorAll('li').forEach(function(li) { li.style.gridColumn = 'span 1'; });
      } else if (val === '2' || val === '4') {
        grid.style.setProperty('grid-template-columns', '1fr 1fr', 'important');
        grid.querySelectorAll('li').forEach(function(li) { li.style.gridColumn = ''; });
      }
    });
  }, 500);
});

window.mossenOpenGuideContent = function() {
  var guideEl = document.getElementById('mossen-meta-guide-tailles');
  var content = guideEl ? guideEl.innerHTML.trim() : '';
  if (!content) { mossenOpenBlancGuide(); return; }
  var overlay = document.createElement('div');
  overlay.id = 'mp-guide-content-overlay';
  overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.4);z-index:2000010;';
  overlay.onclick = function(e) { if (e.target === overlay) overlay.remove(); };
  var panel = document.createElement('div');
  panel.style.cssText = 'position:fixed;bottom:0;left:0;right:0;max-height:85vh;background:#fff;overflow-y:auto;-webkit-overflow-scrolling:touch;border-radius:16px 16px 0 0;padding:24px 20px 40px;z-index:2000011;';
  panel.innerHTML = '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:20px;"><span style="font-family:Arial,sans-serif;font-size:11px;letter-spacing:0.15em;text-transform:uppercase;color:#111;font-weight:700;">Guide des tailles</span><button onclick="document.getElementById(\'mp-guide-content-overlay\').remove()" style="background:none;border:none;cursor:pointer;font-size:20px;color:#999;padding:0;line-height:1;">✕</button></div><div style="font-family:Arial,sans-serif;font-size:12px;color:#111;line-height:1.8;">' + content + '</div>';
  overlay.appendChild(panel);
  document.body.appendChild(overlay);
};

window.mossenOpenBlancGuide = function() {
  if (document.getElementById('mp-guide-blanc')) return;

  var tableauEl = document.getElementById('mossen-meta-tableau-tailles');
  var tableau = tableauEl ? tableauEl.innerHTML.trim() : '';

  var productInfo = (document.querySelector('h1') ? document.querySelector('h1').innerText.toLowerCase() : '') + ' ' + window.location.pathname.toLowerCase();

  var garmentType = 'haut';
  if (productInfo.match(/pantalon|jean|jogger|legging|short/)) garmentType = 'bas';
  else if (productInfo.match(/robe|combinaison/)) garmentType = 'robe';
  else if (productInfo.match(/jupe/)) garmentType = 'jupe';
  else if (productInfo.match(/veste|manteau|blouson|blazer|cardigan|parka|trench/)) garmentType = 'veste';
  else if (productInfo.match(/top|débardeur|body|brassière|bustier/)) garmentType = 'top';

  var legendByType = {
  haut: [
    { titre:'Largeur des épaules', desc:'Posez le vêtement à plat sur une surface plane. Mesurez d\'une couture d\'épaule à l\'autre en ligne droite, sans étirer le tissu.' },
    { titre:'Tour de poitrine', desc:'Posez le vêtement à plat. Mesurez horizontalement d\'un côté à l\'autre, juste sous les emmanchures, là où le vêtement est le plus large au niveau du buste. Multipliez par 2 pour obtenir le tour complet.' },
    { titre:'Longueur', desc:'Posez le vêtement à plat. Mesurez en partant du point le plus haut de l\'épaule (près du col) jusqu\'au bas de l\'ourlet, le long du devant du vêtement.' },
    { titre:'Largeur de dos', desc:'Retournez le vêtement. Mesurez d\'une emmanchure à l\'autre, dans la partie haute du dos, en ligne horizontale.' },
    { titre:'Longueur de manche', desc:'Posez la manche à plat. Mesurez depuis la couture qui relie la manche à l\'épaule jusqu\'à l\'extrémité du poignet.' }
  ],
  top: [
    { titre:'Largeur des épaules', desc:'Posez le top à plat. Mesurez d\'une bretelle à l\'autre en ligne droite, au niveau du haut du buste, là où les bretelles rejoignent le tissu.' },
    { titre:'Tour de poitrine', desc:'Posez le top à plat. Mesurez horizontalement d\'un côté à l\'autre à la hauteur la plus large du buste. Multipliez par 2 pour le tour complet.' },
    { titre:'Longueur', desc:'Posez le top à plat. Mesurez depuis le bord supérieur du vêtement jusqu\'au bas de l\'ourlet, le long du devant.' }
  ],
  veste: [
    { titre:'Largeur des épaules', desc:'Posez la veste à plat, fermée. Mesurez d\'une couture d\'épaule à l\'autre en ligne droite, là où la manche rejoint le corps.' },
    { titre:'Tour de poitrine', desc:'Posez la veste à plat, boutonnée. Mesurez horizontalement d\'un bord à l\'autre, juste sous les emmanchures. Multipliez par 2 pour le tour complet.' },
    { titre:'Longueur', desc:'Posez la veste à plat. Mesurez depuis le point le plus haut de l\'épaule (côté col) jusqu\'au bas du vêtement, le long du devant.' },
    { titre:'Largeur de dos', desc:'Retournez la veste. Mesurez d\'une emmanchure à l\'autre en ligne horizontale, dans la partie haute du dos.' },
    { titre:'Longueur de manche', desc:'Étalez la manche à plat. Mesurez depuis la couture épaule-manche jusqu\'à l\'extrémité du poignet, en suivant la ligne extérieure de la manche.' }
  ],
  bas: [
    { titre:'Tour de taille', desc:'Posez le vêtement à plat. Mesurez la ceinture d\'un bord à l\'autre en ligne droite. Multipliez ce chiffre par 2 pour obtenir le tour de taille complet.' },
    { titre:'Tour de hanches', desc:'Posez le vêtement à plat. Mesurez d\'un côté à l\'autre à l\'endroit le plus large du bassin. Multipliez par 2 pour le tour complet.' },
    { titre:'Longueur totale', desc:'Posez le vêtement à plat. Mesurez depuis le haut de la ceinture jusqu\'au bas de la jambe, le long du côté extérieur. Pour l\'entrejambe, mesurez depuis la couture centrale jusqu\'au bas de la jambe.' }
  ],
  robe: [
    { titre:'Largeur des épaules', desc:'Posez la robe à plat. Mesurez d\'une couture d\'épaule à l\'autre en ligne droite, là où la manche ou la bretelle rejoint le corps.' },
    { titre:'Tour de poitrine', desc:'Posez la robe à plat. Mesurez horizontalement d\'un côté à l\'autre à la hauteur la plus large du buste. Multipliez par 2 pour le tour complet.' },
    { titre:'Tour de taille', desc:'Posez la robe à plat. Mesurez d\'un côté à l\'autre à l\'endroit le plus étroit du vêtement, généralement à la hauteur de la taille. Multipliez par 2 pour le tour complet.' },
    { titre:'Longueur', desc:'Posez la robe à plat. Mesurez depuis le point le plus haut de l\'épaule jusqu\'au bas de l\'ourlet, le long du devant.' }
  ],
  jupe: [
    { titre:'Tour de taille', desc:'Posez la jupe à plat. Mesurez la ceinture d\'un bord à l\'autre en ligne droite. Multipliez par 2 pour obtenir le tour de taille complet.' },
    { titre:'Tour de hanches', desc:'Posez la jupe à plat. Mesurez d\'un côté à l\'autre à l\'endroit le plus large du bassin. Multipliez par 2 pour le tour complet.' },
    { titre:'Longueur', desc:'Posez la jupe à plat. Mesurez depuis le haut de la ceinture jusqu\'au bas de l\'ourlet, le long du côté extérieur.' }
  ]
};

  var currentLegend = legendByType[garmentType] || legendByType['haut'];

  var legendHTML = currentLegend.map(function(item) {
    return '<div style="padding:0 0 24px 0;">' +
      '<p style="font-family:Arial,sans-serif;font-size:11px;font-weight:400;color:#111;letter-spacing:0.12em;text-transform:uppercase;margin:0 0 6px;">' + item.titre + '</p>' +
      '<p style="font-family:Arial,sans-serif;font-size:13px;font-weight:400;color:#555;margin:0;line-height:1.6;">' + item.desc + '</p>' +
    '</div>';
  }).join('');

  var defaultTableauHTML =
  '<p style="font-family:Arial,sans-serif;font-size:11px;font-weight:700;letter-spacing:0.1em;text-transform:uppercase;color:#111;margin:0 0 16px;">Tableau de conversion des tailles</p>' +
  '<div style="overflow-x:auto;margin-bottom:32px;">' +
    '<table style="width:100%;border-collapse:collapse;font-family:Arial,sans-serif;font-size:12px;">' +
      '<thead><tr style="border-bottom:2px solid #e5e5e5;">' +
        '<th style="text-align:left;padding:10px 8px;font-weight:700;letter-spacing:0.06em;color:#111;">FR</th>' +
        '<th style="text-align:left;padding:10px 8px;font-weight:700;letter-spacing:0.06em;color:#111;">INT</th>' +
        '<th style="text-align:left;padding:10px 8px;font-weight:700;letter-spacing:0.06em;color:#111;">UE</th>' +
        '<th style="text-align:left;padding:10px 8px;font-weight:700;letter-spacing:0.06em;color:#111;">IT</th>' +
        '<th style="text-align:left;padding:10px 8px;font-weight:700;letter-spacing:0.06em;color:#111;">UK</th>' +
      '</tr></thead>' +
      '<tbody>' +
        [['34','XXS','32','38','4'],['36','XS','34','40','6'],['38','S','36','42','8'],['40','M','38','44','10'],['42','L','40','46','12'],['44','XL','42','48','14'],['46','XXL','44','50','16'],['48','3XL','46','52','18'],['50','4XL','48','54','20'],['52','5XL','50','56','22'],['54','6XL','52','58','24'],['56','7XL','54','60','26'],['58','8XL','56','62','28'],['60','9XL','58','64','30'],['62','10XL','60','66','32']].map(function(r) {
          return '<tr style="border-bottom:1px solid #f0f0f0;"><td style="padding:10px 8px;font-weight:600;color:#555;">'+r[0]+'</td><td style="padding:10px 8px;color:#111;">'+r[1]+'</td><td style="padding:10px 8px;color:#111;">'+r[2]+'</td><td style="padding:10px 8px;color:#111;">'+r[3]+'</td><td style="padding:10px 8px;color:#111;">'+r[4]+'</td></tr>';
        }).join('') +
      '</tbody>' +
    '</table>' +
  '</div>' +
  '<p style="font-family:Arial,sans-serif;font-size:11px;font-weight:700;letter-spacing:0.1em;text-transform:uppercase;color:#111;margin:0 0 16px;">Mensurations (cm)</p>' +
  '<div style="overflow-x:auto;margin-bottom:32px;">' +
    '<table style="width:100%;border-collapse:collapse;font-family:Arial,sans-serif;font-size:12px;">' +
      '<thead><tr style="border-bottom:2px solid #e5e5e5;">' +
        '<th style="text-align:left;padding:10px 8px;font-weight:700;letter-spacing:0.06em;color:#111;">FR</th>' +
        '<th style="text-align:left;padding:10px 8px;font-weight:700;letter-spacing:0.06em;color:#111;">INT</th>' +
        '<th style="text-align:left;padding:10px 8px;font-weight:700;letter-spacing:0.06em;color:#111;">POITRINE</th>' +
        '<th style="text-align:left;padding:10px 8px;font-weight:700;letter-spacing:0.06em;color:#111;">TAILLE</th>' +
        '<th style="text-align:left;padding:10px 8px;font-weight:700;letter-spacing:0.06em;color:#111;">HANCHES</th>' +
      '</tr></thead>' +
      '<tbody>' +
        [['34','XXS','76','63','85'],['36','XS','80','66','89'],['38','S','84','69','93'],['40','M','88','72','97'],['42','L','92','76','100'],['44','XL','96','80','103'],['46','XXL','100','85','106'],['48','3XL','104','90','109'],['50','4XL','110','96.5','114'],['52','5XL','116','103','119'],['54','6XL','122','109.5','124'],['56','7XL','128','116','130'],['58','8XL','134','122.5','136'],['60','9XL','140','129','142'],['62','10XL','146','135.5','148']].map(function(r) {
          return '<tr style="border-bottom:1px solid #f0f0f0;"><td style="padding:10px 8px;font-weight:600;color:#555;">'+r[0]+'</td><td style="padding:10px 8px;color:#111;">'+r[1]+'</td><td style="padding:10px 8px;color:#111;">'+r[2]+'</td><td style="padding:10px 8px;color:#111;">'+r[3]+'</td><td style="padding:10px 8px;color:#111;">'+r[4]+'</td></tr>';
        }).join('') +
      '</tbody>' +
    '</table>' +
  '</div>';

  var isBagGuide = productInfo.match(/sac|bag|pochette|clutch|maroquin/) !== null;

  var mesuresHTML = isBagGuide ? '' :
    '<div style="margin-top:24px;border-top:1px solid #f0f0f0;">' +
      '<button onclick="mossenToggleMesures(this)" style="width:100%;display:flex;justify-content:space-between;align-items:center;padding:18px 0;background:none;border:none;cursor:pointer;font-family:Arial,sans-serif;font-size:12px;color:#111;text-align:left;">' +
        '<span>Comment mesurer la taille de l\'article</span>' +
        '<svg id="mp-mesure-arrow" width="12" height="7" viewBox="0 0 12 7" fill="none" stroke="#111" stroke-width="1.5" style="transition:transform 0.3s;flex-shrink:0;"><path d="M1 1l5 5 5-5"/></svg>' +
      '</button>' +
      '<div id="mp-mesures-content" style="display:none;">' +
        legendHTML +
      '</div>' +
    '</div>';

  var reassuranceHTML = isBagGuide
    ? '<p style="font-family:Arial,sans-serif;font-size:12px;color:#555;line-height:1.7;margin:16px 0 0;padding:14px 16px;background:#f9f9f9;border-left:2px solid #111;">Pensé pour le quotidien, ce sac accueille sans effort jusqu\'à <strong>8 cahiers</strong>, un classeur et un <strong>ordinateur portable 15 pouces</strong> grâce à son compartiment principal spacieux. Idéal pour les cours comme pour le travail.</p>' +
      '<p style="font-family:Arial,sans-serif;font-size:11px;color:#888;margin:12px 0 0;line-height:1.6;">Coutures renforcées aux points de tension, anses doublées et cuir PU traité anti-abrasion : conçu pour résister à un usage intensif, année après année.</p>'
    : '<p style="font-family:Arial,sans-serif;font-size:12px;color:#555;line-height:1.7;margin:16px 0 0;padding:14px 16px;background:#f9f9f9;border-left:2px solid #111;">Vous hésitez entre deux tailles ? Prenez la plus grande pour un rendu confortable, la plus petite pour un rendu plus ajusté.</p>' +
      '<p style="font-family:Arial,sans-serif;font-size:11px;color:#888;margin:12px 0 0;">Taille incorrecte ? <a href="/policies/refund-policy" style="color:#111;text-decoration:underline;">Échange gratuit sous 30 jours</a>, sans justificatif.</p>';

  var panel = document.createElement('div');
  panel.id = 'mp-guide-blanc';
  panel.style.cssText = 'position:fixed;inset:0;background:#fff;z-index:2000020;overflow-y:auto;-webkit-overflow-scrolling:touch;overscroll-behavior:contain;touch-action:pan-y;';

  panel.innerHTML =
    '<style>#mp-guide-blanc table{width:100%;border-collapse:collapse;margin:16px 0;}#mp-guide-blanc th{background:#f9f9f9;font-family:Arial,sans-serif;font-size:10px;font-weight:700;letter-spacing:0.08em;text-transform:uppercase;padding:12px 10px;border-bottom:2px solid #e5e5e5;color:#111;}#mp-guide-blanc td{font-family:Arial,sans-serif;font-size:12px;padding:12px 10px;border-bottom:1px solid #f0f0f0;color:#111;}#mp-guide-blanc td:first-child{font-weight:600;color:#555;}#mp-guide-blanc tr:last-child td{border-bottom:none;}</style>' +
    '<div style="position:sticky;top:0;background:#fff;z-index:10;border-bottom:1px solid #f0f0f0;">' +
      '<div style="display:flex;justify-content:space-between;align-items:center;padding:20px;">' +
        '<span style="font-family:Arial,sans-serif;font-size:11px;letter-spacing:0.15em;text-transform:uppercase;color:#111;font-weight:700;">Guide des tailles</span>' +
        '<button onclick="document.getElementById(\'mp-guide-blanc\').remove()" style="background:none;border:none;cursor:pointer;font-size:20px;color:#999;padding:0;line-height:1;">✕</button>' +
      '</div>' +
    '</div>' +
    '<div id="mp-guide-blanc-content" style="padding:24px 20px 60px;">' +
      '<div style="padding:0 0 16px;">' +
        '<div style="display:inline-flex;border-radius:50px;padding:3px;gap:0;background:linear-gradient(135deg,rgba(255,255,255,0.45),rgba(255,255,255,0.15));backdrop-filter:blur(20px) saturate(180%);-webkit-backdrop-filter:blur(20px) saturate(180%);border:1px solid rgba(200,200,200,0.5);box-shadow:0 4px 16px rgba(0,0,0,0.08),inset 0 1px 2px rgba(255,255,255,0.8);">' +
          '<button id="mp-unit-cm" onclick="mossenSetUnit(\'cm\')" style="padding:4px 12px;font-family:Arial,sans-serif;font-size:10px;letter-spacing:0.08em;text-transform:uppercase;border:none;cursor:pointer;border-radius:50px;background:rgba(255,255,255,0.9);color:#111;box-shadow:0 2px 8px rgba(0,0,0,0.10),inset 0 1px 2px rgba(255,255,255,0.9);transition:all 0.2s ease;">CM</button>' +
          '<button id="mp-unit-in" onclick="mossenSetUnit(\'in\')" style="padding:4px 12px;font-family:Arial,sans-serif;font-size:10px;letter-spacing:0.08em;text-transform:uppercase;border:none;cursor:pointer;border-radius:50px;background:transparent;color:rgba(0,0,0,0.35);box-shadow:none;transition:all 0.2s ease;">IN</button>' +
        '</div>' +
      '</div>' +
      (tableau ? tableau : defaultTableauHTML) +
      reassuranceHTML +
      mesuresHTML +
      '<div style="margin-top:16px;padding-top:16px;">' +
  '<div id="mp-moss-messages" style="display:flex;flex-direction:column;gap:12px;margin-bottom:16px;"></div>' +
  '<div style="display:flex;flex-direction:column;align-items:flex-start;gap:12px;">' +
          '<button onclick="mossenStartMossChat()" id="mp-moss-cta" style="background:none;border:none;cursor:pointer;padding:0;display:flex;align-items:center;gap:8px;font-family:Arial,sans-serif;font-size:13px;font-weight:400;filter:drop-shadow(0 0 8px rgba(124,58,237,0.4));transition:filter 0.3s ease;">' +
            '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><defs><linearGradient id="mossGrad2" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stop-color="#ec4899"/><stop offset="100%" stop-color="#3b82f6"/></linearGradient></defs><path d="M12 2L14.8 9.2L22 12L14.8 14.8L12 22L9.2 14.8L2 12L9.2 9.2L12 2Z" stroke="url(#mossGrad2)"/></svg>' +
            '<span style="background:linear-gradient(90deg,#7c3aed,#3b82f6);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;">Quelle taille me conseilles-tu ?</span>' +
          '</button>' +
          '<div id="mp-moss-input-wrap" style="display:none;width:100%;box-sizing:border-box;">' +
            '<div style="display:flex;align-items:center;gap:10px;border:1px solid #e5e5e5;border-radius:50px;padding:8px 8px 8px 16px;background:#fafafa;">' +
              '<input id="mp-moss-input" type="text" placeholder="Posez votre question..." onkeydown="if(event.key===\'Enter\')mossenSendMossGuide()" style="flex:1;border:none;outline:none;font-family:Arial,sans-serif;font-size:13px;color:#111;background:transparent;">' +
              '<button onclick="mossenSendMossGuide()" style="background:#111;border:none;border-radius:50%;width:32px;height:32px;display:flex;align-items:center;justify-content:center;cursor:pointer;flex-shrink:0;">' +
                '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>' +
              '</button>' +
            '</div>' +
            '<p style="font-family:Arial,sans-serif;font-size:10px;color:#bbb;text-align:center;margin:8px 0 0;">Moss est une IA et peut se tromper.</p>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>';

  document.body.appendChild(panel);
  window._mpOriginalCells = null;
  window._mpCurrentUnit = 'cm';
};
window.mossenSetUnit = function(unit) {
  if (window._mpCurrentUnit === unit) return;
  window._mpCurrentUnit = unit;
  var content = document.getElementById('mp-guide-blanc-content');
  if (!content) return;
  var cells = content.querySelectorAll('td:not(:first-child)');
  if (!window._mpOriginalCells) {
    window._mpOriginalCells = Array.from(cells).map(function(td) { return td.innerText.trim(); });
  }
  cells.forEach(function(td, i) {
    var original = window._mpOriginalCells[i];
    if (unit === 'in') {
      td.innerText = original.replace(/[\d.]+/g, function(n) { return (parseFloat(n) / 2.54).toFixed(1); });
    } else {
      td.innerText = original;
    }
  });
  var btnCm = document.getElementById('mp-unit-cm');
  var btnIn = document.getElementById('mp-unit-in');
  btnCm.style.background = unit === 'cm' ? 'rgba(255,255,255,0.9)' : 'transparent';
  btnCm.style.color = unit === 'cm' ? '#111' : 'rgba(0,0,0,0.35)';
  btnCm.style.boxShadow = unit === 'cm' ? '0 2px 8px rgba(0,0,0,0.10),inset 0 1px 2px rgba(255,255,255,0.9)' : 'none';
  btnIn.style.background = unit === 'in' ? 'rgba(255,255,255,0.9)' : 'transparent';
  btnIn.style.color = unit === 'in' ? '#111' : 'rgba(0,0,0,0.35)';
  btnIn.style.boxShadow = unit === 'in' ? '0 2px 8px rgba(0,0,0,0.10),inset 0 1px 2px rgba(255,255,255,0.9)' : 'none';
};

window.mossenToggleMesures = function(btn) {
  var content = document.getElementById('mp-mesures-content');
  var arrow = document.getElementById('mp-mesure-arrow');
  var isOpen = content.style.display === 'block';
  content.style.display = isOpen ? 'none' : 'block';
  if (arrow) arrow.style.transform = isOpen ? 'rotate(0deg)' : 'rotate(180deg)';
};

window.mossenStartMossChat = function() {
  document.getElementById('mp-moss-cta').style.display = 'none';
  document.getElementById('mp-moss-input-wrap').style.display = 'block';

  var messages = document.getElementById('mp-moss-messages');
  var intro = document.createElement('div');
  intro.style.cssText = 'display:flex;align-items:flex-start;gap:8px;margin-bottom:4px;';
  intro.innerHTML =
    '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" style="flex-shrink:0;margin-top:3px;"><defs><linearGradient id="mg4" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stop-color="#ec4899"/><stop offset="100%" stop-color="#3b82f6"/></linearGradient></defs><path d="M12 2L14.8 9.2L22 12L14.8 14.8L12 22L9.2 14.8L2 12L9.2 9.2L12 2Z" stroke="url(#mg4)"/></svg>' +
    '<span style="font-size:12px;font-family:Arial,sans-serif;color:#111;line-height:1.7;">Bonjour ! Dites-moi votre morphologie (taille, poids, tour de poitrine) et je vous recommande la bonne taille pour cet article.</span>';
  messages.appendChild(intro);

  setTimeout(function() { document.getElementById('mp-moss-input').focus(); }, 100);
};

window.mossenSendMossGuide = async function() {
  var input = document.getElementById('mp-moss-input');
  var messages = document.getElementById('mp-moss-messages');
  var text = input ? input.value.trim() : '';
  if (!text) return;
  input.value = '';

  var userBubble = document.createElement('div');
  userBubble.style.cssText = 'display:flex;justify-content:flex-end;';
  userBubble.innerHTML = '<span style="background:rgba(0,0,0,0.06);color:#111;border-radius:18px 18px 4px 18px;padding:9px 14px;font-size:12px;font-family:Arial,sans-serif;max-width:80%;line-height:1.6;">' + text + '</span>';
  messages.appendChild(userBubble);

  var botBubble = document.createElement('div');
  botBubble.style.cssText = 'display:flex;align-items:flex-start;gap:8px;';
  botBubble.innerHTML =
    '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="url(#mg3)" stroke-width="2" stroke-linecap="round" style="flex-shrink:0;margin-top:3px;"><defs><linearGradient id="mg3" x1="0%" y1="0%" x2="100%" y2="100%"><stop offset="0%" stop-color="#ec4899"/><stop offset="100%" stop-color="#3b82f6"/></linearGradient></defs><path d="M12 2L14.8 9.2L22 12L14.8 14.8L12 22L9.2 14.8L2 12L9.2 9.2L12 2Z"/></svg>' +
    '<span id="mp-moss-reply" style="font-size:12px;font-family:Arial,sans-serif;color:#bbb;line-height:1.7;max-width:85%;">Moss réfléchit...</span>';
  messages.appendChild(botBubble);

  var replyEl = botBubble.querySelector('#mp-moss-reply');
  messages.scrollTop = messages.scrollHeight;

  try {
    var res = await fetch('https://mossen-marketing-3eyv.vercel.app/api/shopify-chat', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ message: 'Contexte : le client consulte le guide des tailles Maison Mossen. Question : "' + text + '". Réponds en 2-3 phrases max, ton naturel et bienveillant.' })
    });
    var data = await res.json();
    var answer = data.answer || 'Je n\'ai pas pu répondre. Contactez-nous à sav@maisonmossen.com';
    replyEl.style.color = '#111';
    replyEl.textContent = '';
    var words = answer.split(' ');
    var i = 0;
    var iv = setInterval(function() {
      if (i < words.length) {
        replyEl.textContent += (i === 0 ? '' : ' ') + words[i];
        i++;
        messages.scrollTop = messages.scrollHeight;
      } else {
        clearInterval(iv);
      }
    }, 35);
  } catch(e) {
    replyEl.style.color = '#888';
    replyEl.textContent = 'Une erreur est survenue. Contactez-nous à sav@maisonmossen.com';
  }
};

/* ============================================================
   MAISON MOSSEN — CARROUSEL DESKTOP (une image, navigation flèches)
   ============================================================ */
(function () {
  function injectStyle() {
    if (document.getElementById('mm-desk-carousel-styles')) return;
    var s = document.createElement('style');
    s.id = 'mm-desk-carousel-styles';
    s.textContent =
      '@media screen and (min-width: 750px){' +
        'body.template-product .media-gallery{display:none !important;}' +
        '#mm-desk-carousel{position:fixed;top:60px;left:0;width:50vw;height:calc(100vh - 60px);background:#fff;z-index:40;overflow-y:auto;-webkit-overflow-scrolling:touch;box-sizing:border-box;padding:1cm;scrollbar-width:none;}' +
        '#mm-desk-carousel::-webkit-scrollbar{display:none;}' +
        '#mm-desk-stage{display:flex;flex-direction:column;gap:1cm;}' +
        
        /* 1. L'image de base (la 1ère) prend 100% de l'espace disponible */
        '.mm-desk-frame{position:relative;width:100%;aspect-ratio:1130/1600;background:#f9f9f9;overflow:hidden;}' +
        
        /* 2. À partir de la 2ème image, on réduit la largeur pour permettre le décalage (ex: 70%) */
        '.mm-desk-frame:nth-child(n+2){width:70%;}' + 
        
        /* 3. Les images paires (2, 4, 6...) se collent à droite */
        '.mm-desk-frame:nth-child(even){align-self:flex-end;}' + 
        
        /* 4. Les images impaires à partir de la 3ème (3, 5, 7...) se collent à gauche */
        '.mm-desk-frame:nth-child(n+3):nth-child(odd){align-self:flex-start;}' + 
        
        '.mm-desk-frame img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;object-position:center;display:block;cursor:zoom-in;}' +
      '}' +
      '@media screen and (max-width: 749px){#mm-desk-carousel{display:none !important;}}';
    document.head.appendChild(s);
  }

  function collectImages() {
    var imgs = [];
    document.querySelectorAll('.media-gallery .product-media__image, .media-gallery .product-media img, .product-media-container img').forEach(function (img) {
      var src = img.getAttribute('src') || img.currentSrc || '';
      if (!src) return;
      if (src.indexOf('//') === 0) src = 'https:' + src;
      src = src.replace(/([?&])width=\d+/, '$1width=1600');
      if (imgs.indexOf(src) === -1) imgs.push(src);
    });
    return imgs;
  }

  function build() {
    if (window.innerWidth < 750) return;
    if (!window.location.pathname.includes('/products/')) return;
    if (document.getElementById('mm-desk-carousel')) return;

    var imgs = collectImages();
    if (!imgs.length) { setTimeout(build, 300); return; } // attend le rendu du thème

    window._mossenThumbImgs = imgs; // synchronise la lightbox existante

    injectStyle();

    var totalPages = Math.ceil(imgs.length / 2);
    var page = 0;

    var index = 0;
    var car = document.createElement('div');
    car.id = 'mm-desk-carousel';
    car.innerHTML =
      '<div id="mm-desk-stage">' +
        imgs.map(function (src, i) {
          return '<div class="mm-desk-frame"><img class="mm-desk-img" data-i="' + i + '" src="' + src + '" alt=""></div>';
        }).join('') +
      '</div>';
    document.body.appendChild(car);

    /* Retire physiquement la galerie native du DOM sur desktop */
    var nativeGallery = document.querySelector('.media-gallery');
    if (nativeGallery) nativeGallery.remove();

    car.querySelectorAll('.mm-desk-img').forEach(function (im) {
      im.addEventListener('click', function (e) {
        var i = parseInt(im.dataset.i, 10);
        if (window.mossenPreviewImg) window.mossenPreviewImg(imgs[i], e, i);
      });
    });
  }

  function refresh() {
    if (window.innerWidth < 750) {
      var c = document.getElementById('mm-desk-carousel');
      if (c) c.remove();
    } else {
      build();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', build);
  } else {
    build();
  }
  window.addEventListener('resize', function () {
    clearTimeout(window._mmDeskRz);
    window._mmDeskRz = setTimeout(refresh, 200);
  });
})();